export default {
  translation: {
    CHECK_EMAIL_TITLE: "Controlla l'email",
    WELCOME_BACK: "Bentornato!",
    ENTER_YOUR_CREDENTIALS: "Inserisci le tue credenziali per continuare",
    EMAIL_FIELD: "Email",
    CHECK_BUTTON: "Dai un'occhiata",
    EMAIL_IS_REQUIRED: "L'email è obbligatoria",
    CREATE_PASSWORD_TITLE: "Crea password",
    SUBMIT_BUTTON: "Invia",
    LOGIN_TITLE: "Login",
    PASSWORD_FIELD: "Password",
    PLEASE_INPUT_YOUR_PASSWORD: "Inserisci la tua password!",
    FORGOT_PASSWORD: "Ha dimenticato la password?",
    REMEMBER_ME: "Ricordami",
    LOGIN_TO_ACCOUNT_BUTTON: "Accedi all'account",
    SIDEBAR_ORDER_HISTORY: "Cronologia ordini",
    SIDEBAR_SIGNOUT: "Disconnetti",
    FOOTER_MENU_HOME: "Home",
    FOOTER_MENU_SHARE: "Condividi",
    FOOTER_MENU_KWIKCASH: "KwikCash",
    FOOTER_MENU_HISTORY: "Cronologia",
    SHARE_THE_PRODUCTS_TITLE: "Condividi prodotti",
    PLEASE_SELECT_A_CAMPAIGN_TO_SHARE:
      "Seleziona i prodotti per i quali desideri creare un link.",
    CREATE_A_KWIKLINK_BUTTON: "Crea un KwikLink",
    MANAGE_MY_KWIKLINKS: "Gestisci i miei KwikLink",
    KWIK_CASH_TITLE: "1Cash",
    KWIK_LINK_TITLE: "Condividi i prodotti",
    FIELD_PRODUCT: "Prodotto",
    FIELD_QUANTITY: "Quantità",
    FIELD_PRICE: "Prezzo",
    FIELD_KWIKCASH: "KwikCash",
    SHARE_THIS_PRODUCT_TO: "Condividi",
    COPY_LINK: "Copia link",
    RETURN_TO_HOME_BUTTON: "Tornare alla Home",
    COPY_SUCCESS: "Link copiato con successo",
    TOTAL_KWIKCASH_EARNED: "KwikCash totale guadagnato",
    TOTAL_CASHED_OUT: "Totale incassato",
    KWIKCASH_BALANCE: "Saldo KwikCash",
    CASH_OUT_BUTTON: "Incassa",
    WEEK_COL_NAME: "Settimana",
    KWIK_CASH_COL_NAME: "KwikCash",
    PRODUCT_INFO_TITLE: "Info sul prodotto",
    KWIKCASH_VALUE: "Valore KwikCash",
    "'DESCRIPTION': 'Description',": "Descrizione",
    IMPORTANT_INFORMATION: "Informazioni importanti",
    "'INGREDIENTS': 'Ingredients',": "Ingredienti",
    "'USAGE': 'Usage',": "Utilizzo",
    HANDLING_INSTRUCTIONS: "Modalità di conservazione",
    "'MANUFACTURER': 'Manufacturer',": "Produttore",
    ADD_TO_CART_BUTTON: "Aggiungi al carrello",
    YOUR_CART_TITLE: "Il tuo carrello",
    "'PRODUCTS': 'Products',": "Prodotti",
    REMOVE_LINK: "Rimuovi",
    FIELD_TAX: "Tasse",
    FIELD_TOTAL: "Totale",
    PROCEED_TO_CHECKOUT_BUTTON: "Vai alla cassa",
    CHECKOUT_TITLE: "Pagamento",
    SHIPPING_ADDRESS: "Indirizzo di spedizione",
    NEW_LINK: "Nuovo",
    PAYMENT_BREAKDOWN: "Dettagli pagamento",
    SHOW_SAVE_CARDS: "Mostra carte salvate",
    FIELD_NAME_ON_CARD: "Nome sulla carta",
    FIELD_CARD_NUMBER: "Numero di carta",
    FIELD_EXPIRY_YEAR: "Anno di scadenza",
    FIELD_EXPIRY_MONTH: "Mese di scadenza",
    FIELD_CVV: "CVV",
    SAVE_THIS_CARD: "Salva questa carta",
    BILLING_ADDRESS_IS_SAME_SHIPPING_ADDRESS:
      "L'indirizzo di fatturazione è lo stesso dell'indirizzo di spedizione",
    BILLING_ADDRESS: "Indirizzo di fatturazione",
    FIELD_FIRST_NAME: "Nome",
    FIELD_LAST_NAME: "Cognome",
    FIELD_ADDRESS_LINE: "Indirizzo",
    FIELD_ZIP: "Codice postale",
    FIELD_PHONE: "Numero di telefono",
    FIELD_CITY: "Città",
    FIELD_STATE: "Regione",
    FIELD_COUNTRY: "Paese",
    FIELD_NAME: "Nome",
    PLEASE_SELECT: "Seleziona",
    "'SHIPPING': 'Shipping',": "Spedizione",
    CONTINUE_TO_PLACE_ORDER_BUTTON: "Continua ad effettuare l'ordine",
    SAVE_AND_USE_THIS_ADDRESS_BUTTON: "Vai al prossimo",
    "'CONGRATULATIONS': 'Order Complete!',": "Ordine completo!",
    PAYMENT_SUCCESSFUL: "Pagamento riuscito",
    "'STANDARD': 'Standard',": "Standard",
    ORDER_ACCEPTED: "Ordine accettato",
    CHECKOUT_MESSAGE1:
      "Il tuo ordine n. #{{orderId}} è stato effettuato ed è stata inviata un'email di conferma a",
    CHECKOUT_MESSAGE2:
      "Congratulazioni! Guadagna $ 2,5 ogni volta che qualcuno acquista dal tuo codice promozionale! Fai clic sul pulsante Condividi qui sotto.",
    SHARE_THE_PRODUCT_BUTTON: "Kwik e guadagna",
    TRACK_ORDER: "Segui l'ordine",
    WAVES_COL: "Onde",
    NAME_COL: "Nome",
    ORDER_K_CASH_COL: "Ordine totale",
    K_CASH_RATE: "Percentuale K.Cash",
    CASH_HISTORY_TITLE: "Cronologia degli accrediti",
    TRANSFER_TO_BANK_TITLE: "Trasferisci sul conto",
    SAVED_BANK_LINK: "Conto salvato",
    ADD_BANK_LINK: "Aggiungi conto",
    SELECT_LINK: "Seleziona",
    PROCEED_TO_NEXT_BUTTON: "Vai al prossimo",
    FIELD_BANKS_COUNTRY: "Paese della banca",
    FIELD_CURRENCY_CODE: "Codice valuta",
    FIELD_NAME_ON_ACCOUNT: "Nome sul conto",
    FIELD_NAME_ON_ROUTING_NUMBER: "Numero Routing",
    FIELD_ACCOUNT_NUMBER: "Numero di conto",
    FIELD_ACCOUNT_TYPE: "Tipo di conto",
    FIELD_ACCOUNT_TYPE_OPTION_CHECKING: "Conto corrente",
    FIELD_ACCOUNT_TYPE_OPTION_SAVINGS: "Conto risparmi",
    FIELD_SWIFT_CODE_BIC: "Codice Swift/BIC",
    FIELD_BANK_NAME: "Nome della banca",
    FIELD_BANK_NUMBER: "Numero banca",
    FIELD_BRANCH_NAME: "Nome della filiale",
    FIELD_BRANCH_CODE: "Codice della filiale",
    SAFE_KEEP_MESSAGE:
      "Queste informazioni verranno salvate in modo sicuro secondo i Termini di servizio e l'Informativa sulla privacy",
    SAVE_BANK_DETAILS_BUTTON: "Salva le coordinate bancarie",
    AVAILABLE_BALANCE: "Saldo disponibile",
    TRANSFER_TO_INTRODUCE_MESSAGE:
      "Scegli la quantità di denaro che desideri trasferire dal tuo conto KwikCash al conto bancario selezionato.",
    FIELD_AMOUNT: "Quantità",
    SELECTED_BANK: "Conto selezionato",
    VERIFY_BANK_CARD_INFORMATION:
      "Verifica che il saldo del conto e del KwikCash siano corretti. NON PUOI cambiare idea dopo averlo fatto.",
    TRANSACTION_COMPLETE: "Transazione completata!",
    TRANSACTION_CONSEQUENCE_MESSAGE:
      "Il tuo numero di transazione è {{amount}} ed è stato inserito. È stata inviata un'email di conferma a {{email}}",
    TRANSACTION_CONSEQUENCE_MESSAGE2:
      "Attendi fino a 24 ore per l'aggiornamento del saldo KwikCash.",
    RETURN_BUTTON: "Torna alla Home",
    VIEW_TRANSACTION_HISTORY: "Visualizza cronologia transazioni",
    ORDER_TEXT: "Ordine",
    ITEM_LIST_IS_EMPTY: "Seleziona il prodotto",
    CART_MUST_NOT_BE_EMPTY: "Il carrello non può essere vuoto",
    CLICK_SEND_EMAIL:
      "Fare clic sul pulsante per inviare un'email per confermare la password iniziale",
    SELECTED_DATE_GREATER_CURRENT_DATE:
      "La data selezionata deve essere successiva alla data corrente",
    CARD_NUMBER_FORMAT_IS_INCORRECT:
      "Il formato del numero della carta non è corretto",
    ITEM_ADDED_TO_CART: "Hai aggiunto con successo l'articolo al carrello!",
    ORDER_NUMBER: "Numero d'ordine",
    CREATION_TIME: "Order Date",
    ORDER_STATUS: "Stato dell'ordine",
    ARE_YOU_SURE: "Sei sicuro?",
    "'CANCEL': 'Cancel',": "Annulla",
    "'OK': 'Ok',": "OK",
    EMAIL_IS_NOT_UNIQUE_SHARE_LINK:
      "Questo indirizzo email ha già un account registrato su Kwik. Si prega di usare una email differente o di accedere per completare l’ordine.",
    EMAIL_IS_NOT_UNIQUE:
      "Questa email è già registrata su kwik.com. Utilizza un'altra email o vai su kwik.com e accedi per effettuare ordini su questi o più prodotti.",
    EMAIL_IS_NOT_UNIQUE_ARIIX:
      "Questa email risulta già registrata a nome di un cliente di ARIIX. Utilizza un'altra email o vai su kwik.com e accedi con questa email per esplorare più campagne.",
    REQUIRED_FIELD: "Campo obbligatorio",
    INCORRECT_EMAIL_FORMAT: "Formato email errato",
    "'REFUND': 'Refund',": "Rimborso",
    "'DELETE': 'Delete',": "Elimina",
    PLEASE_INPUT_TAGLINK: "Inserisci Tag link",
    PLEASE_INPUT_CITY: "Inserisci la città",
    UPDATE_SUCCESSFULLY: "Aggiornato con successo",
    TAGLINK_TEXT: "Tag link",
    EXPLORATION_TITLE: "Esplora",
    SEE_ALL_NUM_PRODUCTS: "Vedi tutti i {{prodNumber}} prodotti",
    LEARN_MORE_LINK: "Per saperne di più",
    KWIKCASH_VALUE_MESS: "Valore KwikCash",
    SHARE_YOUR_LINK: "CONDIVIDI IL LINK",
    SEND_LINK_AND_EARN_KWIKCASH_MESS: "Invia link e guadagna KwikCash",
    PRICE_TEXT: "PREZZO",
    OUT_OF_STOCK_TEXT: "Esaurito",
    ORDER_HISTORY_TEXT: "Cronologia ordini",
    ORDER_HISTORY_TIPS_NEED_PURCHASE: "Devi prima aver effettuato un acquisto!",
    ORDER_HISTORY_EXPLORE_PRODUCTS: "Esplora prodotti",
    ORDER_HISTORY_ORDER_ON: "Ordine del",
    ORDER_DETAIL_EXPECTED_DATE: "Data prevista",
    ORDER_DETAIL_TRACKING_ID: "ID tracking",
    ORDER_DETAIL_BILLING_INFO_SAME_AS_SHIPPING:
      "Indirizzo di fatturazione identico a quello di spedizione",
    ORDER_DETAIL_ORIGINAL_PRICE: "Prezzo originale",
    ORDER_DETAIL_SHIPPINGN_HANDING: "Spedizione e manipolazione",
    KWIK_CASH_AVAILABLE_BALANCE: "Saldo disponibile",
    KWIK_CASH_PENDING_BALANCE: "Saldo in sospeso",
    KWIK_CASH_VIEW_HISTORY: "Visualizza cronologia",
    KWIK_CASH_TRANSFER_BANK: "Trasferisci sul conto",
    ACCOUNT_NUMBER_4:
      "Il numero di conto non può essere inferiore a 4 caratteri",
    KWIK_CASH_PENDING: "in sospeso",
    KWIK_CASH_PAID: "pagato",
    KWIK_CASH_FULFILLED: "completato",
    CAMPAIGNS_SHARE_A_CAMPAIGN: "Condividi una campagna",
    CAMPAIGNS_ACTIVE_CAMPAIGN: "Campagna attiva",
    CAMPAIGNS_NODATA_TEXT: "Per cominciare, trova un prodotto da sostenere",
    CAMPAIGNS_EXPLORE_PRODUCTS: "Esplora prodotti",
    PROGRESS_LOADING: "Caricamento in corso...",
    LOGIN_WELCOME_BACK: "Bentornato!",
    LOGIN_CREDENTIALS: "Inserisci le tue credenziali per continuare",
    LOGIN_LABEL_USERNAME: "Nome utente",
    LOGIN_PLACEHOLDER_USERNAME: "Nome utente o email",
    LOGIN_REQUIRED_USERNAME: "Nome utente richiesto",
    LOGIN__LABEL_PASSWORD: "Password",
    LOGIN_PLACEHOLDER_PASSWORD: "Password",
    LOGIN_REQUIRED_PASSWORD: "Inserisci la tua password!",
    LOGIN_REMEMBER_ME: "Ricordami",
    LOGIN_FORGOT_PASSWORD: "Hai dimenticato la password?",
    LOGIN_BUTTON_LOGIN: "Login",
    LOGIN_NEED_ACCOUNT: "Hai bisogno di un account?",
    LOGIN_CREATE_ACCOUNT: "Crea un nuovo account",
    VIEWS_REGISTER_1_CREATE_ACCOUNT: "Crea il tuo account",
    VIEWS_REGISTER_1_FIELDS_REQUIRED:
      "Compila il modulo seguente. Tutti i campi sono obbligatori.",
    VIEWS_REGISTER_1_LABEL_EMAIL_ADDRESS: "Indirizzo email (unico)",
    VIEWS_REGISTER_1_PLACEHOLDER_EMAIL_ADDRESS: "Indirizzo email (unico)",
    VIEWS_REGISTER_1_REQUIRED_EMAIL: "L’indirizzo email non può rimanere vuoto",
    VIEWS_REGISTER_1_LABEL_FIRST_NAME: "Nome",
    VIEWS_REGISTER_1_PLACEHOLDER_FIRST_NAME: "Nome",
    VIEWS_REGISTER_1_REQUIRED_FIRST_NAME: "Il nome non può rimanere vuoto",
    VIEWS_REGISTER_1_LABEL_LAST_NAME: "Cognome",
    VIEWS_REGISTER_1_PLACEHOLDER_LAST_NAME: "Cognome",
    VIEWS_REGISTER_1_REQUIRED_LAST_NAME: "Il cognome non può rimanere vuoto",
    VIEWS_REGISTER_1_LABEL_USER_NAME: "Nome utente (unico)",
    VIEWS_REGISTER_1_PLACEHOLDER_USER_NAME: "Nome utente (unico)",
    VIEWS_REGISTER_1_REQUIRED_USER_NAME:
      "Il nome utente non può rimanere vuoto",
    VIEWS_REGISTER_1_LABEL_PHONE: "Numero di telefono",
    VIEWS_REGISTER_1_PLACEHOLDER_PHONE: "Numero di telefono (unico)",
    VIEWS_REGISTER_1_REQUIRED_PHONE:
      "Il numero di telefono non può rimanere vuoto",
    VIEWS_REGISTER_1_BUTTON_NEXT: "Avanti",
    VIEWS_REGISTER_1_TIPS_DIGIT_SENT:
      "Un codice di 4 cifre è stato inviato al tuo indirizzo email",
    VIEWS_REGISTER_1_TIPS_EMAIL_REGISTERED:
      "Questo indirizzo è già stato registrato su Kwik.",
    VIEWS_REGISTER_1_BUTTON_EMAIL_REGISTERED_FORGOT_PASSWORD:
      "Hai dimenticato la password?",
    VIEWS_REGISTER_1_BUTTON_EMAIL_REGISTERED_CANCEL: "Annulla",
    VIEWS_REGISTER_1_TIPS_USERNAME_REGISTERED:
      "Questo nome utente è già stato registrato su Kwik.",
    VIEWS_REGISTER_1_BUTTON_OK: "Ok",
    VIEWS_REGISTER_2_VERIFICATION: "Verifica",
    VIEWS_REGISTER_2_TO_VERIFY: "Per verificare la tua identità",
    VIEWS_REGISTER_2_TIPS_ENTER:
      "Inserisci il codice a 4 cifre che ti è stato inviato all’indirizzo",
    VIEWS_REGISTER_2_BUTTON_NEXT: "Avanti",
    VIEWS_REGISTER_2_NEED_CODE: "Non hai ancora ricevuto il codice?",
    VIEWS_REGISTER_2_LINK_RESEND: "Invia di nuovo",
    VIEWS_REGISTER_2_LOADING: "Caricamento in corso...",
    VIEWS_REGISTER_3_TITLE_PASSWORD_CREATE: "Crea una nuova password",
    VIEWS_REGISTER_3_TITLE_ENTER_NEW_PASSWORD:
      "Inserisci una nuova password sicura",
    VIEWS_REGISTER_3_CREATE_LABEL: "Crea password",
    VIEWS_REGISTER_3_CREATE_PLACEHOLDER: "Crea password",
    VIEWS_REGISTER_3_CREATE_REQUIRED: "Inserisci la tua password!",
    VIEWS_REGISTER_3_CONFIRM_LABEL: "Conferma password",
    VIEWS_REGISTER_3_CONFIRM_PLACEHOLDER: "Conferma password",
    VIEWS_REGISTER_3_CONFIRM_REQUIRED: "Inserisci la tua password!",
    VIEWS_REGISTER_3_TOAST_PATTERN:
      "La password deve avere una lunghezza minima di otto caratteri e contenere almeno una lettera maiuscola, una minuscola e un numero.",
    VIEWS_REGISTER_3_TIPS_MATCH: "Le due password non corrispondono",
    VIEWS_REGISTER_3_BUTTON_NEXT: "Avanti",
    VIEWS_REGISTER_3_BUTTON_BACK: "Indietro",
    VIEWS_REGISTER_3_LOADING: "Caricamento in corso...",
    VIEWS_REGISTER_4_TITLE: "Carica una foto del profilo",
    VIEWS_REGISTER_4_MESSAGE:
      "Questo ti renderà popolare e aumenterà la fiducia nel tuo account.",
    VIEWS_REGISTER_4_BUTTON_NEXT: "Vai al prossimo",
    VIEWS_REGISTER_4_TIPS_NOT_NOW: "Non ora?",
    VIEWS_REGISTER_4_LINK_DO_LATER: "Più tardi",
    VIEWS_REGISTER_5_TITLE: "Crea il tuo account",
    VIEWS_REGISTER_5_MESSAGE: "Fornisci le informazioni seguenti qui sotto",
    VIEWS_REGISTER_5_TIPS_YOUR_BIO: "La tua biografia",
    VIEWS_REGISTER_5_PLACEHOLDER_TYPING: "Digita qui...",
    VIEWS_REGISTER_5_BUTTON_NEXT: "Invia e vai Avanti",
    VIEWS_REGISTER_5_TIPS_NOT_NOW: "Non ora?",
    VIEWS_REGISTER_5_LINK_DO_LATER: "Più tardi",
    VIEWS_REGISTER_6_BUTTON_BACK: "Indietro",
    VIEWS_REGISTER_6_TITLE: "Fornisci le tue info personali",
    VIEWS_REGISTER_6_MESSAGE: "Fornisci delle informazioni.",
    VIEWS_REGISTER_6_ADDRESS_LINE_1: "Indirizzo 1",
    VIEWS_REGISTER_6_ADDRESS_LINE_2: "Indirizzo 2",
    VIEWS_REGISTER_6_POSTAL_CODE: "Codice postale",
    VIEWS_REGISTER_6_BUTTON_NEXT: "Avanti",
    VIEWS_REGISTER_6_COUNTRY_USA: "Stati Uniti",
    VIEWS_REGISTER_6_COUNTRY_CHA: "Cina",
    VIEWS_REGISTER_SSO_1_TIPS_EMAIL_REGISTERED:
      "Questo nome utente è già stato registrato su Kwikclick. ",
    VIEWS_REGISTER_SSO_1_BUTTON_OK: "Ok",
    VIEWS_REGISTER_SSO_1_TIPS_SIGNUP: "Iscrizione",
    VIEWS_REGISTER_SSO_1_TITLE: "Crea il tuo account",
    VIEWS_REGISTER_SSO_1_MESSAGE:
      "Congratulazioni! Il tuo ID e la tua password NewAge sono stati verificati. Fornisci le informazioni seguenti qui sotto",
    VIEWS_REGISTER_SSO_1_TIPS_EMAIL:
      "Email (verificheremo l’unicità del tuo indirizzo email)",
    VIEWS_REGISTER_SSO_1_TIPS_FIRST: "Nome",
    VIEWS_REGISTER_SSO_1_REQUIRED_FIRST: "Il nome non può rimanere vuoto",
    VIEWS_REGISTER_SSO_1_TIPS_LAST: "Cognome",
    VIEWS_REGISTER_SSO_1_REQUIRED_LAST: "Il cognome non può rimanere vuoto",
    VIEWS_REGISTER_SSO_1_TIPS_USERNAME:
      "Nome utente (verificheremo l’unicità del tuo nome utente)",
    VIEWS_REGISTER_SSO_1_REQUIRED_USERNAME:
      "Il nome utente non può rimanere vuoto",
    VIEWS_REGISTER_SSO_1_TIPS_PHONE: "Numero di telefono",
    VIEWS_REGISTER_SSO_1_REQUIRED_PHONE:
      "Il numero di telefono non può rimanere vuoto",
    VIEWS_REGISTER_SSO_1_BUTTON_NEXT: "Avanti",
    CAMPAIGNS_BUTTON_OK: "Ok",
    CAMPAIGNS_LOADING: "Caricamento in corso...",
    CAMPAIGNS_CANNOT_SHARE_MESSAGE_1:
      "Siamo spiacenti, non puoi condividere il prodotto ",
    CAMPAIGNS_CANNOT_SHARE_MESSAGE_2:
      "Ti preghiamo di acquistare questo prodotto ora o di fare domanda di idoneità.",
    CAMPAIGNS_TITLE_STATS: "Dati statistici",
    CAMPAIGNS_TIPS_CASH_EARNED: "Totale KwikCash guadagnato questa settimana",
    CAMPAIGNS_TIPS_TOTAL_KWIKCASH_EARNED: "Totale KwikCash guadagnato",
    CAMPAIGNS_TIPS_GENERATE_SALES: "Vendite generate",
    CAMPAIGNS_TITLE_CAMPAIGNS: "Campagne",
    CAMPAIGNS_TIPS_VIEW_DETAIL: "(Fare clic per visualizzare i dettagli)",
    CAMPAIGNS_TITLE_ALL_STATS: "Dati statistici di tutte le campagne",
    CAMPAIGNS_TIPS_KWIK_INFO: "Info su Kwik",
    CAMPAIGNS_TITLE_TOTAL_BUYERS: "Acquirenti totali",
    CAMPAIGNS_BUTTON_QR_CODE: "Codice QR",
    CAMPAIGNS_BUTTON_COPY_LINK: "Copia link",
    CAMPAIGNS_HEADER_TITLE_CAMPAIGNS_STATS: "Dati statistici sulla campagna",
    CAMPAIGNS_TITLE_TOTAL_CUSTOMERS: "Clienti totali",
    CAMPAIGNS_BUTTON_VIEW_DATA: "Visualizza dati",
    CAMPAIGNS_TITLE_ACTIVE_CAMPAIGN: "Campagna attiva",
    CAMPAIGNS_TITLE_SHARE_CAMPAIGN: "Condividi una campagna",
    CAMPAIGNS_TITLE_CAMPAIGN_DETAILS: "Dettagli campagna",
    CAMPAIGNS_TITLE_WAVES: "Onde",
    CAMPAIGNS_TIPS_KWIKCASH_EARNED: "1Cash guadagnato",
    CAMPAIGNS_TITLE_BUYER: "Acquirente",
    CAMPAIGNS_COLOR_MEANS_GREEN: "Verde indica che KwikCash è disponibile",
    CAMPAIGNS_COLOR_MEANS_YELLOW: "Giallo indica che KwikCash è in sospeso",
    CAMPAIGNS_COLOR_MEANS_RED: "Rosso indica che KwikCash non è erogabile",
    CAMPAIGNS_TITLE_KWIK_INFO: "Info su Kwik",
    SHARE_LINK_IMAGE_5M: "Le immagini non possono superare i 5 MB",
    SHARE_LINK_REFERRED_BY: "Presentato da",
    SHARE_LINK_DESCRIPTION: "Descrizione",
    SHARE_LINK_ADD_TO_CART: "Aggiungi al carrello",
    SHARE_LINK_PRODUCTS_DESC: "Descrizione prodotto",
    SHARE_LINK_LEAVE_MESSAGE: "Lascia una recensione",
    SHARE_LINK_LEARN_MORE: "Per saperne di più",
    SHARE_LINK_REVIEWS: "Recensioni",
    SHARE_LINK_RATE_THE_PRODUCT: "Valuta il prodotto",
    SHARE_LINK_SHARE_YOUR_THOUGHTS_ON_THE_PRODUCT:
      "Condividi le tue impressioni sul prodotto",
    SHARE_LINK_ADD_AN_IMAGE_TO_YOUR_REVIEW:
      "Aggiungi un’immagine alla tua recensione",
    SHARE_LINK_DRAG_AND_DROP: "TRASCINA E RILASCIA",
    SHARE_LINK_YOUR_FILES_TO_ASSETS_OR_BROWSE:
      "i tuoi file in asset, o <span>naviga</span>",
    SHARE_LINK_LEAVE_REVIEW: "Lascia una recensione",
    SHARE_LINK_MY_CART: "Carrello",
    SHARE_LINK_CHECKOUT: "ACQUISTA",
    SHARE_LINK_CHECKOUT2: "Acquista",
    SHARE_LINK_DISCOUNT: "Sconto",
    SHARE_LINK_WILL_BE_CALCULATED_AT_CHECKOUT: "Sarà calcolato alla cassa",
    SHARE_LINK_RETURNING_CUSTOMER: "Cliente esistente",
    SHARE_LINK_SIGN_IN_FOR_FASTER_CHECKOUT:
      "Accedi per completare l’acquisto più velocemente",
    SHARE_LINK_USERNAME_OR_EMAIL: "Nome utente o email",
    SHARE_LINK_USERNAME_IS_REQUIRED: "Nome utente richiesto",
    SHARE_LINK_PASSWORD: "Password",
    SHARE_LINK_OR: "O",
    SHARE_LINK_NEW_CUSTOMER: "Nuovo cliente",
    SHARE_LINK_DONT_HAVE_A_MESSAGE:
      "Non hai ancora un account Kwik? Questo è il primo step! Completa la transazione per iniziare a impostare il tuo account!",
    SHARE_LINK_ADD_NEW_ADDRESS: "Aggiungi un nuovo indirizzo",
    SHARE_LINK_TO_MAKE_SURE_MESSAGE:
      "Per garantire che il collegamento funzioni correttamente, assicurarsi di usare questa email sull’account Kwik.",
    SHARE_LINK_ADDRESS: "Indirizzo",
    SHARE_LINK_APARTMENT_SUITE_ETC: "Appartamento, interno, ecc. (facoltativo)",
    SHARE_LINK_APT_SUITE_ETC: "App., interno, ecc. (facoltativo)",
    SHARE_LINK_CITY: "Città",
    SHARE_LINK_COUNTRY: "Paese",
    SHARE_LINK_STATE: "Regione",
    SHARE_LINK_ZIP_CODE: "Codice postale",
    SHARE_LINK_PHONE: "Telefono",
    SHARE_LINK_CANCEL: "Annulla",
    SHARE_LINK_PRODUCTS: "Prodotti",
    SHARE_LINK_SHIPPING: "Spedizione",
    SHARE_LINK_TOTAL: "Totale",
    SHARE_LINK_ENTER_YOUR_CARD_DETAILS: "Inserisci i dati della tua carta",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_NAME: "Inserisci il nome sulla carta!",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_NUMBER: "Inserisci il numero di carta!",
    SHARE_LINK_EXPIRATION_DATE: "Data di scadenza",
    SHARE_LINK_EXPIRATION_YEAR: "Anno di scadenza",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_CVV: "Inserisci il CVV della tua carta!",
    SHARE_LINK_BILLING_ADDRESS_IS_THE_SAME_MESSAGE:
      "L’indirizzo di fatturazione è identico all’indirizzo di spedizione",
    SHARE_LINK_ENTER_YOUR_BILLING_ADDRESS:
      "Inserisci il tuo indirizzo di fatturazione",
    SHARE_LINK_SAVE_THIS_CARD: "Salva questa carta",
    SHARE_LINK_COUNTINUE: "Continua",
    SHARE_LINK_SHIPPING_ADDRESS: "Indirizzo di spedizione",
    SHARE_LINK_EDIT: "Modifica",
    SHARE_LINK_SHIPPING_AND_HANDLING: "Spedizione e manipolazione",
    SHARE_LINK_CHANGE: "Cambia",
    SHARE_LINK_PRICE_COUNT_ITEM: "Prezzo ({{count}} articolo)",
    SHARE_LINK_PRICE_TAX: "Tasse",
    SHARE_LINK_PRICE: "PREZZO",
    SHARE_LINK_PLACE_YOUR_ORDER: "Fai un ordine",
    SHARE_LINK_PAYMENT_SUCCESSFUL: "Pagamento completato con successo!",
    SHARE_LINK_CONGRATS_MESSAGE:
      "Congratulazioni! Guadagna KwikCash ogni volta che qualcuno usa il tuo codice promo! Fai clic sul pulsante Condividi di seguito.",
    SHARE_LINK_SHARE_YOUR_LINK: "CONDIVIDI IL LINK",
    SHARE_LINK_CREATE_MY_ACCOUNT: "Crea account",
    SHARE_LINK_DOWNLOAD_IMAGE: "Scarica immagine",
    SHARE_LINK_COPY_LINK: "Copia link",
    SHARE_LINK_ORDER_ACCEPTED: "Ordine accettato",
    SHARE_LINK_SELECT_THE_PRODUCTS_YOU_WOULD_LIKE:
      "Seleziona i prodotti che desideri",
    SHARE_LINK_PRODUCT_NOT_AVAILABLE:
      "    Il prodotto scelto non è disponibile nel paese selezionato",
    SHARE_LINK_OUT_OF_STOCK: "Esaurito",
    SHARE_LINK_PRICE2: "Prezzo",
    SHARE_LINK_ADD: "Aggiungi",
    SHARE_LINK_CONTINUE_TO_CHECKOUT: "Passa alla cassa",
    SHARE_LINK_SO_YOURE_ALREADY_MESSAGE:
      "Sei già in {{totalAlreadyJoin}} delle {{totalCpgn}} campagne selezionate. Quando completi l’acquisto dei prodotti, sarai con {{referName}} nelle {{totalCanJoin}} campagne selezionate",
    SHARE_LINK_SINCE_YOU_ALREADY_MESSAGE:
      "Dal momento che sei già in questa campagna con {{originalName}}, lui/lei riceverà il credito.",
    SHARE_LINK_SINCE_YOU_HAVE_ALREADY_MESSAGE:
      "Visto che sei già in tutte e {{totalAlreadyJoin}} le campagne. Quando completi l’acquisto dei prodotti, lui/lei riceverà il credito.",
    SHARE_LINK_CLICK_TO_SEE_DETAILS: "Fai clic per vedere i dettagli",
    SHARE_LINK_REFERRER: "Persona che fa il referral",
    SHARE_LINK_CAMPAIGN: "Campagna",
    SHARE_LINK_CAMPAIGNS_TYPE: "Tipo di campagna",
    SHARE_LINK_DATE_JOINED: "Data di iscrizione",
    SHARE_LINK_SINGLE_CAMPAIGN: "Campagna singola",
    SHARE_LINK_ULTI_PRODUCT: "ulti - prodotto",
    SHARE_LINK_KWIKCASH: "1Cash",
    SHARE_LINK_QUANTITY: "Quantità",
    SHARE_LINK_SUBTOTAL: "Subtotale",
    SHARE_LINK_PLEASE_INPUT_YOUR_FIRSTNAME: "Inserisci il tuo Nome!",
    SHARE_LINK_PLEASE_INPUT_YOUR_LASTNAME: "Inserisci il tuo Cognome!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ZIP: "Inserisci il tuo codice postale!",
    SHARE_LINK_PLEASE_INPUT_YOUR_STATE: "Inserisci la tua regione!",
    SHARE_LINK_PLEASE_INPUT_YOUR_CITY: "Inserisci la tua città!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ADDRESS_LINE1: "Inserisci il tuo indirizzo 1!",
    SHARE_LINK_PLEASE_SELECT_YOUR_STATE: "Seleziona la tua regione!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ADDRESS_PHONE:
      "Inserisci il tuo numero di telefono!",
    SHARE_LINK_EXISTING_KWIK_USER_LOGIN_HERE:
      "Utente Kwik esistente? Accedi qui",
    SHARE_LINK_STEP_ADDRESS: "Indirizzo",
    SHARE_LINK_STEP_PAYMENTS: "Pagamenti",
    SHARE_LINK_STEP_SUMMARY: "Riepilogo",
    SHARE_LINK_BUTTON_LOGIN: "Login",
    SHARE_LINK_BUTTON_CONTINUE: "Continua",
    SHOPPING_NEW_AGE_PV: "PV NewAge",
    SHOPPING_PRODUCT_DESCRIPTION: "Descrizione prodotto",
    SHOPPING_REVIEWS: "Recensioni",
    SHOPPING_LEAVE_REVIEW: "Lascia una recensione",
    SHOPPING_RATE_PRODUCT: "Valuta il prodotto",
    SHOPPING_SHARE_THOUGHTS_PRODUCT:
      "Condividi le tue impressioni sul prodotto",
    SHOPPING_PLACEHOLDER_TYPING: "Inizia digitando",
    SHOPPING_PLEASE_TYPING: "Inserisci Inizia digitando",
    SHOPPING_TIPS_ADD_IMAGE: "Aggiungi un’immagine alla tua recensione",
    SHOPPING_BUTTON_REMOVE: "Rimuovi",
    SHOPPING_TIPS_IMAGE_UPLOAD_1: "i tuoi file in asset, o ",
    SHOPPING_TIPS_IMAGE_UPLOAD_2: "naviga",
    SHOPPING_BUTTON_LEAVE_REVIEW: "Lascia una recensione",
    SHOPPING_BUTTON_DRAG_DROP: "TRASCINA E RILASCIA",
    SHOPPING_BUTTON_CHECKOUT: "Acquista",
    SHOPPING_SHARE_LINK_TEXT_PRICE: "PREZZO",
    SHOPPING_SHARE_LINK_TEXT_NEW_AGE_PV: "PV NewAge",
    SHOPPING_BUTTON_QR_CODE: "Codice QR",
    SHOPPING_BUTTON_COPY_LINK: "Copia link",
    SHOPPING_BUTTON_QUICK_SHARE: "Quick Share",
    SHOPPING_BUTTON_DOWNLOAD_IMAGE: "scarica immagine",
    SHOPPING_BUTTON_X: "X",
    SHOPPING_BUTTON_CANCEL: "Annulla",
    SHOPPING_CART_TEXT_PRICE: "Prezzo",
    SHOPPING_CART_TEXT_KWIKASH: "KwikCash",
    SHOPPING_CART_TEXT_SHIP_FROM: "Spedisci da",
    SHOPPING_CART_TEXT_SUBTOTAL: "Subtotale",
    SHOPPING_BUTTON_CHANGE: "Cambia",
    SHOPPING_TITLE_COUPON: "Coupon",
    SHOPPING_OPTION_SELECT_COUPON: "Seleziona un coupon tra quelli disponibili",
    SHOPPING_REQUIRED_INPUT_CARD_NAME: "Inserisci il nome sulla carta!",
    SHOPPING_REQUIRED_INPUT_CARD_NUMBER: "Inserisci il numero di carta!",
    SHOPPING_TEXT_EXPIRATION_DATE: "Data di scadenza",
    SHOPPING_TEXT_EXPIRATION_YEAR: "Anno di scadenza",
    SHOPPING_REQUIRED_INPUT_CARD_CVV: "Inserisci il CVV della tua carta!",
    SHOPPING_REQUIRED_INPUT_FIRST_NAME: "Inserisci il tuo Nome!",
    SHOPPING_REQUIRED_INPUT_LAST_NAME: "Inserisci il tuo Cognome!",
    SHOPPING_REQUIRED_INPUT_ADDRESS_1: "Inserisci il tuo indirizzo 1!",
    SHOPPING_REQUIRED_INPUT_STATE: "Seleziona la tua regione!",
    SHOPPING_REQUIRED_INPUT_CITY: "Inserisci la tua città!",
    SHOPPING_REQUIRED_INPUT_ZIP: "Inserisci il tuo codice postale!",
    SHOPPING_REQUIRED_INPUT_PHONE: "Inserisci il tuo numero di telefono!",
    SHOPPING_TEXT_SHIPPING_HANDING: "Spedizione e gestione",
    SHOPPING_TEXT_SHOW_SAVED_CARD: "Mostra carte salvate",
    SHOPPING_SUCCESS_TEXT_CONGRATS:
      "Congratulazioni! Guadagna KwikCash ogni volta che qualcuno usa il tuo codice promo! Fai clic sul pulsante Condividi di seguito.",
    SHOPPING_PAYMENT_TEXT_PAYMENT_SUCCESSFUL:
      "Pagamento completato con successo!",
    SHOPPING_PAYMENT_TEXT_SHARE_LINK: "CONDIVIDI IL LINK",
    SHOPPING_PAYMENT_TEXT_ORDER_ACCEPTED: "Ordine accettato",
    SHOPPING_PASSWORD_TITLE_FORGOT: "Password dimenticata?",
    SHOPPING_PASSWORD_TEXT_VERIFY: "Per verificare la tua identità",
    SHOPPING_PASSWORD_TEXT_ENTER_EMAIL:
      "Inserisci l’email di registrazione per ricevere le istruzioni per resettare la password",
    SHOPPING_PASSWORD_LABEL_EMAIL: "Indirizzo email",
    SHOPPING_PASSWORD_PLACEHOLDER_EMAIL: "Indirizzo email",
    SHOPPING_PASSWORD_REQUIRED_EMAIL: "L'email è obbligatoria",
    SHOPPING_PASSWORD_BUTTON_RESET: "Resetta password",
    SHOPPING_PASSWORD_SEND_EMAIL: "Email inviata!",
    SHOPPING_PASSWORD_SEND_CHECK_INBOX:
      "Controlla la tua casella di posta e fai clic sul link per\n resettare la password.",
    SHOPPING_PASSWORD_SEND_BACK_TO_LOGIN: "Ritorna al login",
    SHOPPING_PASSWORD_SEND_TEXT_DONT_RECEIVE: "Non hai ricevuto il link?",
    SHOPPING_PASSWORD_SEND_BUTTON_RESEND: "Invia di nuovo",
    SHOPPING_PASSWORD_SEND_BUTTON_BACK: "Indietro",
    HEADER_PHOTO_EDIT_IMAGE: "Modifica immagine",
    HEADER_PHOTO_OK: "OK",
    HEADER_PHOTO_CANCEL: "Annulla",
    HEADER_HOME: "Home",
    HEADER_KWIKCASH: "KwikCash",
    HEADER_CAMPAIGNS: "Campagne",
    HEADER_ORDER_HISTORY: "Cronologia ordini",
    HEADER_SIGN_OUT: "Esci",
    HEADER_LOGOUT: "Disconnetti",
    LOGIN_HEADER_TITLE_REPORT_ISSUE: "Riferisci un problema",
    LOGIN_HEADER_LABEL_SUBJECT: "Oggetto",
    LOGIN_HEADER_PLACEHOLDER_SUBJECT: "Riassumi il tuo problema qui",
    LOGIN_HEADER_LABEL_DESCRIPTION: "Descrizione",
    LOGIN_HEADER_PLACEHOLDER_DESCRIPTION:
      "Descrivi il problema in dettaglio qui...",
    WELINK_ADDRESS_WE_RE_CURRENTLY:
      "We’re Currently Focused On expanding in the following Metro areas:  Las Vegas, NV; Pheonix, AZ, TUSCON, AZ. WE’LL BE BRINGING OUR WIRELESS FIBER TO EVEN MORE MARKETS IN 2022",
    WELINK_ADDRESS_FIRST_NAME: "Nome",
    WELINK_ADDRESS_LAST_NAME: "Cognome",
    WELINK_ADDRESS_COMPANY_NAME: "Nome Società",
    WELINK_ADDRESS_EMAIL: "Email",
    WELINK_ADDRESS_ADDRESS: "Indirizzo",
    WELINK_ADDRESS_APT_SUITE_ETC_OPTIONAL: "App., interno, ecc. (facoltativo)",
    WELINK_ADDRESS_CITY: "Città",
    WELINK_ADDRESS_COUNTRY: "Paese",
    WELINK_ADDRESS_STATE: "Regione",
    WELINK_ADDRESS_ZIP_CODE: "Codice postale",
    WELINK_ADDRESS_PHONE: "Telefono",
    WELINK_ADDRESS_HOW_MANY_W2_EMPLOYEES_DO_YOU_HAVE:
      "How many w2 Employees do you have?",
    WELINK_ADDRESS_HAS_YOUR_BUSINESS_BEEN:
      "Has your business been impacted or changed by COVID?",
    WELINK_ADDRESS_HAS_YOUR_BUSINESS_HAD:
      'Has your business had a supply chain "disruption" to your business?',
    WELINK_ADDRESS_PROCEED_TO_NEXT: "Vai al prossimo",
    FIELD_PROVINCE: "Provincia",
    FIELD_TOWN_CITY: "Città",
    FIELD_POSTAL_CODE: "Codice postale",
    SSONEWAGE_IF_YOU_ALREADY_SET_UP_MESSAGE:
      'Se hai già creato un account Kwik seguendo "Iscriviti con NewAge", puoi anche accedere all’app Kwik con l’email e la password Kwik <a href="/">facendo clic qui</a>.',
    SSONEWAGE_SIGN_IN_WITH_NEWAGE: "Iscriviti con NewAge",
    SSONEWAGE_LINK_AN_EXISTING_ACCOUNT_WITH_NEWAGE_ACCOUNT:
      "Collega un account esistente all'account NewAge",
    SSONEWAGE_WELCOME_BACK: "Bentornato!",
    SSONEWAGE_ENTER_YOUR_CREDENTIALS_TO_CONTINUE:
      "Inserisci le tue credenziali per continuare",
    SSONEWAGE_EMAIL: "Email",
    SSONEWAGE_USERNAME: "Nome utente",
    SSONEWAGE_USERNAME_IS_REQUIRED: "Nome utente richiesto",
    SSONEWAGE_PASSWORD: "Password",
    SSONEWAGE_NEXT: "Avanti",
    SSONEWAGE_PLEASE_VERIFY_KWIK_ACCOUNT_INFOMATION:
      "Ti preghiamo di verificare le informazioni del tuo account Kwik",
    SSONEWAGE_KWIK_ACCOUNT_EMAIL: "Email dell'account Kwik",
    SSONEWAGE_FIRST_NAME: "Nome",
    SSONEWAGE_LAST_NAME: "Cognome",
    SSONEWAGE_PHONE_NUMBER: "Numero di telefono",
    SSONEWAGE_NEWAGE_ID: "ID NewAge",
    SSONEWAGE_YOUR_KWIK_ACCOUNT_HAS_ALREADY_MESSAGE:
      "Il tuo account Kwik è già stato collegato a questo ID NewAge. Se questo è il tuo ID NewAge corretto, non sono richieste ulteriori azioni.",
    SSONEWAGE_IF_THIS_IS_NOT_MESSAGE:
      "Se questo non è il tuo ID NewAge corretto, puoi aggiornarlo.",
    SSONEWAGE_UPDATE: "Aggiorna",
    SSONEWAGE_IS_THIS_YOU: "Sei tu?",
    SSONEWAGE_YES_AND_PROCEED_TO_NEXT_STEP:
      "Sì e procedi al passaggio successivo",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_THIS_MESSAGE:
      "I nostri archivi indicano che questo ID NewAge {{newAgeID}} è collegato a un altro account Kwik. Ti preghiamo di verificare il tuo ID NewAge e riprovare più tardi. Grazie!",
    SSONEWAGE_OK: "OK",
    SSONEWAGE_CONDRATULATIONS_YOUR_NEWAGE_ID_MESSAGE:
      "Congratulazioni! Il tuo ID e la tua password NewAge sono stati verificati. Desideri collegare questo ID NewAge al tuo account Kwik?",
    SSONEWAGE_YES: "Sì",
    SSONEWAGE_NO: "No",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_MESSAGE:
      "Questo nome utente è già stato registrato su Kwik.",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_THIS_EMAIL_MESSAGE:
      "Questo indirizzo email è già stato registrato su Kwik.",
    SSONEWAGE_FORGOT_PASSWORD: "Password dimenticata",
    FIELD_DUTY: "Imposta",
    SHARE_LINK_BTGIN_QUALIFYING: "Inizia a qualificarti",
    "'KWIKCASH': 'KwikCash',": "KwikCash",
    "'CONNECTED': 'Connected!',": "Sei connesso!",
    ADD_BANK_ACCOUNT: "Aggiungi conto in banca",
    CONNECTED_YOUR_ACCOUNT: "Abbiamo collegato il tuo account a",
    KWIKCASH_SUCCESSFULLY_ADDED_1: "Abbiamo aggiunto con successo questo",
    KWIKCASH_SUCCESSFULLY_ADDED_2:
      "al tuo account! Ora dobbiamo solo verificare che tu sia il titolare di questo conto in banca. Ecco come faremo",
    KWIKCASH_PROCESSING_STEP_1:
      "Nei prossimi 1 - 3 giorni lavorativi, faremo due piccoli depositi nel tuo account. Gli importi saranno inferiori a 1$ USD.",
    KWIKCASH_PROCESSING_STEP_2:
      "Quando questi depositi compariranno sul tuo conto, inserisci nella pagina seguente gli importi che vedi",
    KWIKCASH_PROCESSING_STEP_3: "Inizia a trasferire denaro!",
    "'COMPLETE': 'Complete',": "Completa",
    ENTER_AMOUNT: "Inserisci importo",
    TRANSFER_AMOUNT_DESC:
      "Scegli l’importo che desideri trasferire dal tuo KwikCash al conto bancario selezionato.",
    KWIKCASH_SELECT_BANK_ACCOUNT: "Seleziona conto in banca",
    KWIKCASH_AMOUNT_TO_TRANSFER: "Importo da trasferire",
    KWIKCASH_ADD_ACCOUNT: "Aggiungi conto",
    KWIKCASH_PLEASE_CONFIRM: "Confermare",
    KWIKCASH_TRANSFER_AMOUNT: "Importo da trasferire KwikCash",
    KWIKCASH_TO: "a",
    KWIKCASH_PROCESSING_FEE: "Tassa di elaborazione:",
    KWIKCASH_NET_CASHOUT: "Trasferimento netto:",
    KWIKCASH_TRANSFER: "Trasferimento",
    KWIKCASH_CONFIRM: "Conferma",
    KWIKCASH_CANCEL: "Annulla",
    KWIKCASH_AMOUNT: "Quantità",
    KWIKCASH_BANK_NAME: "Nome banca",
    KWIKCASH_NEXT: "Avanti",
    KWIKCASH_TRANSFER_SUCCESS_1: "Il numero di transazione è",
    KWIKCASH_TRANSFER_SUCCESS_2:
      "ed è stato assegnato. Una email di conferma è stata inviata a",
    KWIKCASH_TRANSFER_SUCCESS_3:
      "Attendi fino a 24 ore affinché il saldo di KwikCash sia aggiornato",
    KWIKCASH_BACK_KWIKCASH: "Ritorna in 1Cash",
    KWIKCASH_SUCCESS_HEADER: "Successo!",
    KWIKCASH_PHONE_HEADER: "Verifica del telefono",
    KWIKCASH_PHONE_1: "Verificare l’identità",
    KWIKCASH_PHONE_2:
      "Inserisci il codice a 4 cifre che ti è stato inviato all’indirizzo",
    KWIKCASH_DIDNT_GET_CODE: "Non hai ricevuto il codice?",
    KWIKCASH_RESEND_IT: "Invia di nuovo",
    KWIKCASH_THE_BANK_NAME: "Il conto in banca",
    KWIKCASH_BANK_LINKED: "è stato collegato al tuo conto",
    KWIKCASH_ENTER_DEPOSIT_DESC:
      "Inserisci i due importi che abbiamo depositato nel tuo conto",
    KWIKCASH_DEPOSIT_1: "Importo depositato 1",
    KWIKCASH_DEPOSIT_2: "Importo depositato 2",
    KWIKCASH_DEPOSIT_DESC:
      "Potrebbe volerci del tempo prima che i depositi appaiano sul tuo conto. Attendi 1-3 giorni per vedere gli importi.",
    KWIKCASH_VERIFY: "Verifica",
    KWIKCASH_BACK: "Indietro",
    KWIKCASH_BANK_VERIFY: "Verifica il conto in banca",
    KWIKCASH_HISTORY: "Cronologia di KwikCash",
    KWIKCASH_NO_TRANSACTIONS: "Nessuna transazione recente",
    KWIKCASH_CONNECT: "Collega",
    KWIKCASH_BANK_ACCOUNTS: "Conti in banca",
    KWIKCASH_PENDING: "in sospeso",
    KWIKCASH_CONNECT_TO: "Collega a",
    KWIKCASH_FEATURE_TBA:
      "Siamo spiacenti, questa funzione non è ancora disponibile. Riprova più avanti",
    KWIKCASH_LINKED_ACCOUNTS: "Account collegati",
    KWIKCASH_VALIDATION_MESSAGE:
      "Compila il modulo seguente. Tutti i campi sono obbligatori.",
    VENDOR_ALL_VENDORS: "Tutti i venditori",
    VENDOR_CAMPAIGNS: "Campagne",
    VENDOR_CAMPAIGN_LOGO: "Logo campagna",
    VENDOR_CAMPAIGN_NAME: "Nome campagna",
    VENDOR_MARKET: "Mercato",
    VENDOR_CURRENCY: "Valuta",
    VENDOR_START_DATE: "Data di inizio",
    VENDOR_END_DATE: "Data di fine",
    VENDOR_ACTIONS: "Azioni",
    VENDOR_EDIT: "Modifica",
    VENDOR_DELETE: "Elimina",
    VENDOR_BACK_TO_CAMP_LIST: "Ritorna all’elenco campagne",
    VENDOR_CAMP_DETAIL: "Dettaglio campagna",
    VENDOR_UPDATE: "Aggiorna",
    VENDOR_SAVE: "Salva",
    VENDOR_CANCEL: "Annulla",
    VENDOR_PLS_INPUT_CAMP_NAME: "Inserire il  nome campagna!",
    VENDOR_PLS_SELECT_ONE: "Selezionare un’opzione!",
    VENDOR_PRTS: "Acquisto richiesto per la condivisione",
    VENDOR_NPRTS: "    Nessun acquisto richiesto per condividere",
    VENDOR_FREE_TO_SHARE: "Condivisione libera",
    VENDOR_CAMP_IMAGE: "Immagine campagna",
    VENDOR_DRAG_AND_DROP: "TRASCINA E RILASCIA",
    VENDOR_YFTA: "i tuoi file in asset, o ",
    VENDOR_BROWSE: "naviga",
    VENDOR_IMAGE: "Immagine",
    VENDOR_PRODUCT_NAME: "Nome prodotto",
    VENDOR_AC_NAME: "Nome campagna/azioni",
    VENDOR_TPHBATTC: "Questo prodotto è stato assegnato alla campagna",
    VENDOR_AYSYWT_DELETE: "Eliminare?",
    VENDOR_YCLTC_TIPS:
      "Impossibile collegare la campagna al prodotto perché appartengono a venditori diversi.",
    VENDOR_SEARCH_TIPS: "Cerca per prodotto, cliente, ecc..",
    VENDOR_PRODUCT_ID: "ID prodotto",
    VENDOR_COUNTRY: "Paese",
    VENDOR_REMOVE_FROM_CAMP: "rimuovi dalle campagne",
    VENDOR_CUSTOMERS: "Clienti",
    VENDOR_HEAD: "Intestazione",
    VENDOR_USER_NAME: "Nome utente",
    VENDOR_USER_ID: "ID utente",
    VENDOR_EMAIL_ADDRESS: "Indirizzo email",
    VENDOR_PHONE_NUMBER: "Numero di telefono",
    VENDOR_BACK_TO_CUSTOMER_LIST: "Ritorna all’Elenco clienti",
    VENDOR_USER_PROFILE: "Profilo utente",
    VENDOR_UPDATE_PROFILE: "Aggiorna profilo",
    VENDOR_FIRST_ROMAN_NAME: "Nome in caratteri romani",
    VENDOR_LAST_ROMAN_NAME: "Cognome in caratteri romani",
    VENDOR_FIRST_NATIVE_NAME: "Nome all’anagrafe",
    VENDOR_LAST_NATIVE_NAME: "Cognome all’anagrafe",
    VENDOR_ADD_LINE_1: "Indirizzo 1",
    VENDOR_ADD_LINE_2: "Indirizzo 2",
    VENDOR_CITY: "Città",
    VENDOR_STATE: "Regione",
    VENDOR_ZIP_CODE: "Codice postale",
    VENDOR_BIO: "Biografia",
    VENDOR_BIO_TIPS:
      "Breve e semplice. Racconta chi sei al mondo. Tutti saranno in grado di vedere la tua biografia.",
    VENDOR_STATUS: "Stato",
    VENDOR_ORDER_HISTORY: "Cronologia ordini",
    VENDOR_ORDERS: "Ordini",
    VENDOR_DATE: "Data",
    VENDOR_CUSTOMER: "Cliente",
    VENDOR_PAYMENT_STATUS: "Stato pagamento",
    VENDOR_FULFILLMENT_STATUS: "Stato completamento",
    VENDOR_PRICE: "Prezzo",
    VENDOR_ALL_ORDERS: "Tutti gli ordini",
    VENDOR_OPERATE: "Aziona",
    VENDOR_EXPORT: "Esporta",
    VENDOR_ORDER_ID: "ID ordine",
    VENDOR_MARK_AS_FULFILLED: "Segna come Completato",
    VENDOR_ALL_STATUS: "Tutti gli stati",
    VENDOR_PLS_SELECT: "Selezionare",
    VENDOR_START_TIME_TO_END_TIME: "Data di inizio - Data di fine",
    VENDOR_PLS_INPUT_STTET: "Inserisci la Data di inizio - Data di fine!",
    VENDOR_TRACKING: "Tracking",
    VENDOR_REFUNDED: "Rimborsato",
    VENDOR_STAFF_DELETE_TIPS: "Eliminare?",
    VENDOR_STAFF: "Staff",
    VENDOR_ADD_STAFF: "Aggiungi Staff",
    VENDOR_FULL_NAME: "Nome completo",
    VENDOR_DEPARTMENT: "Dipartimento",
    VENDOR_ROLE: "Ruolo",
    VENDOR_ADD: "Aggiungi",
    VENDOR_PFTFB: "Completa  il modulo seguente.",
    VENDOR_PWD: "Password",
    VENDOR_PSYR: "Seleziona il tuo ruolo!",
    VENDOR_PIYUI: "Inserisci il tuo ID utente!",
    VENDOR_PIYUN: "Inserisci il tuo nome utente!",
    VENDOR_PIYP: "Inserisci la tua password!",
    VENDOR_PIYE: "Inserisci la tua email!",
    VENDOR_BSE: "Acquista. Condividi. Guadagna.",
    VENDOR_BSE_DESC:
      "Kwik è una nuova piattaforma di mercato che collega i brand ai loro fan, creando una potente forza di vendita del passaparola.",
    VENDOR_PETIMBTAYA:
      "Inserisci le info menzionate di seguito per accedere al tuo account.",
    VENDOR_PIYEOU: "Inserisci la tua email o il nome utente!",
    VENDOR_KEEP_SIGN_IN: "Resta collegato",
    VENDOR_DONT_HAVE_ACCOUNT: "Non hai ancora un account?",
    VENDOR_CREATE_ONE: "Creane uno",
    VENDOR_PPTREATRP:
      "Fornisci l’indirizzo email registrato per resettare la password.",
    VENDOR_ALREADY_KNOW_PASSWORD: "Conosco la mia password",
    VENDOR_GO_TO_SIGNIN: "Accedi",
    VENDOR_PCYI_CTLTRYP:
      "Controlla la tua casella di posta e fai clic sul link per resettare la password.",
    VENDOR_DIDNOT_RECEIVE_THE_LINK: "Non hai ricevuto il link?",
    VENDOR_CHOOSE_NEW_PWD: "Scegli una nuova password",
    VENDOR_EAUPTCYNP:
      "Inserisci una password unica per creare la tua nuova password",
    VENDOR_NEW_PWD: "Nuova password",
    VENDOR_PIYCP: "Inserisci la password confermata!",
    VENDOR_SUCESS: "Successo",
    VENDOR_YAHBC_PL: "Il tuo account è stato creato. Accedi",
    VENDOR_CYBAN: "Crea subito il tuo account aziendale.",
    VENDOR_PPUWSITCYA: "Inserisci alcune informazioni per creare un account.",
    VENDOR_BUSINESS_NAME: "Nome azienda",
    VENDOR_PIBN: "Inserisci il nome azienda",
    VENDOR_BPN: "Numero di telefono azienda",
    VENDOR_PIPN: "Inserisci il numero di telefono",
    VENDOR_EAFCA: "Indirizzo email per account aziendale",
    VENDOR_PIEA: "Inserisci l’indirizzo email",
    VENDOR_PIP: "Inserisci password",
    VENDOR_CYP: "Conferma password",
    VENDOR_PICP: "Completa il campo conferma password",
    VENDOR_INCONSISTENT_PWD: "Le password non corrispondono",
    VENDOR_IAGREETOTHE: "Acconsento",
    VENDOR_TERMS_CONDITIONS: "ai termini e alle condizioni",
    VENDOR_PCTT_CONDITONS_AGREEMENT: "Verifica i termini e le condizioni!",
    VENDOR_BUSINESS_INFO: "Informazioni commerciali",
    VENDOR_BUSINESS_INFO_DESC:
      "Si noti che queste informazioni non sono necessarie per l’iscrizione, ma lo sono per l’avvio dell’attività.",
    VENDOR_BUSINESS_TYPE: "Tipo azienda",
    VENDOR_PLS_INPUT_BUSINESS_TYPE: "Inserisci il tipo azienda",
    VENDOR_SSN_EIN: "NIN (O ERN se business)",
    VENDOR_PLS_INPUT_SSN: "Inserire NIN",
    VENDOR_WHO_REFER_YOU_TO_KWIK: "Chi ti ha consigliato Kwik?",
    VENDOR_JSWCGTCTTRP: "Così possiamo premiare la persona giusta.",
    VENDOR_PLS_INPUT_FN: "Inserisci il nome",
    VENDOR_PLS_INPUT_LN: "Inserisci il cognome",
    VENDOR_PLS_INPUT_EA: "Inserisci l’indirizzo email",
    VENDOR_BRAND_INDUSTRY: "Settore brand",
    VENDOR_PLS_INPUT_BRAND_INDUSTRY: "Selezionare il settore brand",
    VENDOR_CONTACT_INFO: "Informazioni di contatto",
    VENDOR_CONTACT_INFO_DESC:
      "Il tuo brand sarà in sospeso fino alla sua approvazione. Dobbiamo contattare qualcuno.",
    VENDOR_BUSINESS_URL: "URL aziendale",
    VENDOR_CR: "Fatturato aziendale (fatturato annuale anno precedente)",
    VENDOR_PLS_INPUT_CR: "Inserisci il fatturato aziendale",
    VENDOR_SUCCESS: "Successo",
    VENDOR_REGISTER_SUCCESS_1:
      "Grazie per aver compilato  le informazioni di profilo del brand.",
    VENDOR_REGISTER_SUCCESS_2:
      "Un membro del nostro Team dei brand ti contatterà presto per raccogliere maggiori informazioni e per assisterti nell’integrazione dei tuoi prodotti su Kwik!",
    VENDOR_REGISTER_SUCCESS_3: "Grazie per la pazienza.",
    VENDOR_REGISTER_SUCCESS_4: "Tempo stimato: 1-3 giorni",
    VENDOR_KWIK_HOME: "Home di Kwik",
    VENDOR_STILL_PENDING: "Ancora in sospeso",
    VENDOR_REGISTER_PENDING_1:
      "Siamo spiacenti, il nostro Team di gestione dei brand è molto impegnato in questo momento e l’integrazione richiederà più tempo del previsto.",
    VENDOR_REGISTER_PENDING_2:
      "Stiamo facendo del nostro meglio per integrare ogni brand su Kwik.",
    VENDOR_REGISTER_PENDING_3:
      "Usa le tue credenziali di accesso del brand per accedere e vedere cosa vedranno gli utenti!",
    VENDOR_CHECK_OUT_USER: "Verifica l’esperienza dell’utente",
    VENDOR_USER_USERNAME: "Nome utente",
    DASHBOARD_HI_USER_NAME: "Ciao,{{userName}}",
    DASHBOARD_ANALYTIC_REPORT: "Report analitico",
    DASHBOARD_SEARCH_FOR_PRODUCT_PLACEHOLDER:
      "Cerca per prodotto, cliente, ecc..",
    DASHBOARD_TOTAL_EARNINGS: "Guadagni totali",
    DASHBOARD_EARNINGS_REPORT: "Report sui guadagni",
    DASHBOARD_HERE_IS_THE_UPDATE_OF_YOUR_EARNING:
      "Qui trovi gli aggiornamenti sui tuoi guadagni.",
    DASHBOARD_THIS_WEEK_ITEM: "Questa settimana",
    DASHBOARD_THIS_MONTH_ITEM: "Questo mese",
    DASHBOARD_THIS_YEAR_ITEM: "Quest’anno",
    DASHBOARD_YOUR_TOTAL_EARNINGS: "I tuoi guadagni totali",
    DASHBOARD_GET_ALL_THE_EARNING_MESSAGE:
      "Ricevi tutti i guadagni della settimana, del mese, dell’anno in un unico posto.",
    DASHBOARD_REVENUE: "Entrate",
    DASHBOARD_USERS: "Utenti",
    DASHBOARD_ALL_USERS: "Tutti gli utenti",
    DASHBOARD_NEW_USERS: "Nuovi utenti",
    DASHBOARD_TOP_SELLING_PRODUCTS: "Prodotti più venduti",
    DASHBOARD_IMAGE_TH: "Immagine",
    DASHBOARD_PRODUCT_NAME_TH: "Nome prodotto",
    DASHBOARD_STATUS_TH: "Stato",
    DASHBOARD_PRICE_TH: "Prezzo",
    DASHBOARD_SALES_TH: "Vendite",
    DASHBOARD_KWIKCASH_VALUE_TH: "Valore KwikCash",
    DASHBOARD_INVENTORY_IN_STOCK: "{{inventory}} in magazzino",
    DASHBOARD_TOP_EARNERS: "Venditori top",
    DASHBOARD_ACTIVITY: "Attività",
    DASHBOARD_PURCHASED: "acquistato",
    PRODUCTS_PRODUCTS_TITLE: "Prodotti",
    PRODUCTS_IMAGE_TH: "Immagine",
    PRODUCTS_PRODUCT_NAME_TH: "Nome prodotto",
    PRODUCTS_PRODUCT_ID_TH: "ID prodotto ",
    PRODUCTS_COUNTRY_TH: "Paese",
    PRODUCTS_CURRENCY_TH: "Valuta",
    PRODUCTS_TYPE_TH: "Tipo",
    PRODUCTS_PRICE_TH: "Prezzo",
    PRODUCTS_BUDGET_TH: "Budget",
    PRODUCTS_KWIKCASH_VALUE_TH: "Valore KwikCash",
    PRODUCTS_ACTIONS_TH: "Azioni",
    PRODUCTS_EDIT_BUTTON: "Modifica",
    PRODUCTS_PREVIEW_BUTTON: "    Anteprima",
    PRODUCTS_DETAIL_UPDATE_PRODUCT: "Aggiorna prodotto",
    PRODUCTS_DETAIL_ADD_PRODUCT: "Aggiungi prodotto",
    PRODUCTS_DETAIL_PLEASE_FILL_THE_FORM_BELLOW:
      "Completare il modulo seguente.",
    PRODUCTS_DETAIL_CANCEL_BUTTON: "Annulla",
    PRODUCTS_DETAIL_SAVE_PRODUCT: "Salva prodotto",
    PRODUCTS_DETAIL_COUNTRY: "Paese",
    PRODUCTS_DETAIL_PLEASE_SELECT_COUNTRY: "Selezionare il Paese!",
    PRODUCTS_DETAIL_PLEASE_SELECT_WAREHOUSE: "    Seleziona Magazzino!",
    PRODUCTS_DETAIL_SELECT_COUNTRY: "Seleziona il Paese",
    PRODUCTS_DETAIL_CURRENCY: "Valuta",
    PRODUCTS_DETAIL_SELECT_CURRENCY: "Seleziona la valuta",
    PRODUCTS_DETAIL_WAREHOUSE: "Magazzino",
    PRODUCTS_DETAIL_SELECT_WAREHOUSE: "Seleziona magazzino",
    PRODUCTS_DETAIL_GENERAL_INFO: "Informazioni generali",
    PRODUCTS_DETAIL_PRODUCT_NAME: "Nome prodotto",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_PRODUCT_NAME:
      "Inserire il nome prodotto!",
    PRODUCTS_DETAIL_PRODUCT_SHORT_DESCRIPTION:
      "Breve descrizione prodotto (massimo 200 caratteri)",
    PRODUCTS_DETAIL_ADD_PRODUCT_IMAGE: "Aggiungi immagine prodotto",
    PRODUCTS_DETAIL_REMOVE: "Rimuovi",
    PRODUCTS_DETAIL_DRAG_AND_DROP: "TRASCINA E RILASCIA",
    PRODUCTS_DETAIL_YOUR_FILES_TO_ASSETS:
      "i tuoi file in asset o <span>naviga</span>",
    PRODUCTS_DETAIL_ACCEPTED_FILE_TYPE:
      "Tipi di file accettati: Solo PNG, JPEG. ",
    PRODUCTS_DETAIL_RETURN_POLICY: "Politica di reso",
    PRODUCTS_DETAIL_PLEASE_ENTER_THE_NUMBER: "Inserire il numero",
    PRODUCTS_DETAIL_DAYS: "Giorni",
    PRODUCTS_DETAIL_ADD_PRODUCT_VIDEO: "Aggiungi video del prodotto",
    PRODUCTS_DETAIL_VIDEO_URL: "URL video",
    PRODUCTS_DETAIL_PRICING: "Prezzo",
    PRODUCTS_DETAIL_PRICE: "Prezzo",
    PRODUCTS_DETAIL_COMPARE_AT_PRICE: "Confronta al prezzo (prezzo di vendita)",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_SALE_PRICE:
      "Inserire il prezzo di vendita!",
    PRODUCTS_DETAIL_BUDGET: "Budget",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_BUDGET: "Inserire il budget!",
    PRODUCTS_DETAIL_FULL_KWIK_CASH: "Intero KwikCash",
    PRODUCTS_DETAIL_1ST_WAVE_COMMISSION_RATE: "Tasso di commissioni 1a Onda",
    PRODUCTS_DETAIL_VAT_RATE: "Aliquota IVA",
    PRODUCTS_DETAIL_TAX_RATE: "Aliquota IVA",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_VAT_RATE: "Inserire  l’aliquota IVA!",
    PRODUCTS_DETAIL_VAT_INCLUSIVE: "IVA inclusa",
    PRODUCTS_DETAIL_TAX_INCLUSIVE: "IVA inclusa",
    PRODUCTS_DETAIL_TAX_CATEGORY: "Categoria fiscale",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_TAX_CATEGORY:
      "Inserire la categoria fiscale!",
    PRODUCTS_DETAIL_DUTY_RATE: "Aliquota dazio",
    PROUDCTS_DETAIL_DUTY_INCLUSIVE: "Dazio incluso",
    PRODUCTS_DETAIL_NEWAGE_CAMPAIGN: "Campagna NewAge",
    PRODUCTS_DETAIL_FULFILED_BY_NEWAGE: "Realizzato da NewAge",
    PRODUCTS_DETAIL_PV: "PV",
    PRODUCTS_DETAIL_INVENTORY: "Inventario",
    PRODUCTS_DETAIL_SKU_STOCK_KEPING_UNIT: "SKU (Stock Keeping Unit)",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_SKU: "Inserisci il tuo SKU!",
    PRODUCTS_DETAIL_QUANTITY: "Quantità",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_INVENTORY: "Inserire  l’inventario!",
    PRODUCTS_DETAIL_SHIPPING: "Spedizione",
    PRODUCTS_DETAIL_WEIGHT: "Peso",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_WEIGHT: "Inserire il peso!",
    PRODUCTS_DETAIL_CANADA_NFR_LIMITS: "Limiti NFR Canada",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_NFR_LIMITS: "Inserire i limiti NFR!",
    PRODUCTS_DETAIL_PRODUCT_STATUS: "Stato prodotto",
    PRODUCTS_DETAIL_SCHEDULE_LAUNCH_TIME: "Programma orario di lancio",
    PRODUCTS_DETAIL_PRODUCT_LONG_DESCRIPTION: "Descrizione lunga del prodotto",
    PRODUCTS_DETAIL_ORGANIZATION: "Organizzazione",
    PRODUCTS_DETAIL_PRODUCT_CATEGORY: "Categoria prodotto",
    PRODUCTS_DETAIL_PLEASE_SELECT_YOUR_PRODUCT_CATEGORY:
      "Selezionare la categoria di prodotto!",
    PRODUCTS_DETAIL_PLEASE_SELECT: "Selezionare",
    PRODUCTS_DETAIL_SUBCATEGORY: "Sottocategoria",
    PRODUCTS_DETAIL_PLEASE_SELECT_YOUR_SUBCATEGORY:
      "Selezionare la sottocategoria!",
    PRODUCTS_DETAIL_VARIANTS_INFO: "Info sulle varianti",
    PRODUCTS_DETAIL_VARIANT_NAME: "Nome variante",
    PRODUCTS_DETAIL_ADD_OPTION: "Aggiungi opzione",
    PRODUCTS_DETAIL_ADD_VARIANT: "Aggiungi variante",
    PRODUCTS_DETAIL_VARIANTS_TH: "Varianti",
    PRODUCTS_DETAIL_IMAGE_URL_TH1: "    Immagine1",
    PRODUCTS_DETAIL_IMAGE_URL_TH2: "    Immagine2",
    PRODUCTS_DETAIL_IMAGE_URL_TH3: "    Immagine3",
    PRODUCTS_DETAIL_IMAGE_URL_TH4: "    Immagine4",
    PRODUCTS_DETAIL_DETELE_TH: "Elimina",
    PRODUCTS_DETAIL_DELETE_IT_TH: "Eliminare?",
    PRODUCTS_DETAIL_SKU_TH: "SKU",
    PRODUCTS_DETAIL_PRICE_TH: "PREZZO",
    PRODUCTS_DETAIL_COMPARE_TO_TH: "CONFRONTA_CON",
    PRODUCTS_DETAIL_POINTS_TH: "    PUNTI",
    PRODUCTS_DETAIL_BUDGET_TH: "BUDGET",
    PRODUCTS_DETAIL_KCASH_TH: "KCASH",
    PRODUCTS_DETAIL_INVENTORY_TH: "INVENTARIO",
    PRODUCTS_DETAIL_START_DATE_TH: "DATA_INIZIO",
    PRODUCTS_DETAIL_END_DATE_TH: "DATA_FINE",
    PRODUCTS_DETAIL_STATUS_TH: "STATO",
    PRODUCTS_DETAIL_ACTIVE: "Attivo",
    PRODUCTS_DETAIL_HIDDEN: "Nascosto",
    PRODUCTS_DETAIL_WEIGHT_TH: "PESO",
    WAREHOUSE_PRODUCTS: "Prodotti",
    WAREHOUSE_WAREHOUSE: "Magazzino",
    WAREHOUSE_ADD_WAREHOUSE_BUTTON: "Aggiungi magazzino",
    WAREHOUSE_NAME_TH: "Nome",
    WAREHOUSE_COUNTRY_TH: "Paese",
    WAREHOUSE_ADDRESS1_TH: "Indirizzo 1",
    WAREHOUSE_ADDRESS2_TH: "Indirizzo 2",
    WAREHOUSE_CITY_TH: "Città",
    WAREHOUSE_STATE_TH: "Stato",
    WAREHOUSE_POSTAL_CODE_TH: "Codice postale",
    WAREHOUSE_CONTACT_TH: "Contatti",
    WAREHOUSE_PHONE_TH: "Telefono",
    WAREHOUSE_SHIPPING_VENDOR_TH: "Venditore spedizione",
    WAREHOUSE_ACTIONS_TH: "Azioni",
    WAREHOUSE_EDIT_BUTTON: "Modifica",
    WAREHOUSE_DETAIL_BACK_TO_WAREHOUSE_LIST: "Ritorna all’Elenco magazzini",
    WAREHOUSE_DETAIL_WAREHOUSE_DETAIL: "Dettaglio magazzino",
    WAREHOUSE_DETAIL_UPDATE: "Aggiorna",
    WAREHOUSE_DETAIL_SAVE: "Salva",
    WAREHOUSE_DETAIL_CANCEL: "Annulla",
    WAREHOUSE_DETAIL_FORM_NAME: "Nome",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_NAME: "Inserisci nome!",
    WAREHOUSE_DETAIL_FORM_COUNTRY: "Paese",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_COUNTRY: "Inserire il Paese!",
    WAREHOUSE_DETAIL_FORM_SELECT_COUNTRY: "Seleziona il Paese",
    WAREHOUSE_DETAIL_FORM_PLEASE_SELECT: "Selezionare",
    WAREHOUSE_DETAIL_FORM_ADDRESS1: "Indirizzo 1",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_ADDR1: "Compilare linea indirizzo 1!",
    WAREHOUSE_DETAIL_FORM_ADDRESS2: "Indirizzo 2",
    WAREHOUSE_DETAIL_FORM_CITY: "Città",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_CITY: "Inserire la città",
    WAREHOUSE_DETAIL_FORM_STATE: "Regione",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_STATE: "Inserire la regione!",
    WAREHOUSE_DETAIL_FORM_POSTAL_CODE: "Codice postale",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_POSTAL_CODE:
      "Inserire il codice postale!",
    WAREHOUSE_DETAIL_FORM_CONTACT: "Contatti",
    WAREHOUSE_DETAIL_FORM_PHONE: "Telefono",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_PHONE: "Inserire il telefono!",
    WAREHOUSE_DETAIL_FORM_SHIPPING_VENDOR: "Venditore spedizione",
    INVENTORY_PRODUCTS: "Prodotti",
    INVENTORY_INVENTORY: "Inventario",
    INVENTORY_IMAGE: "Immagine",
    INVENTORY_PRODUCT_NAME: "Nome prodotto",
    INVENTORY_SUPPLIER: "Fornitore",
    INVENTORY_SKU: "Nr SKU",
    INVENTORY_QTY_ALLOTED: "Quantità assegnata",
    INVENTORY_QTY_SOLD: "Quantità venduta",
    INVENTORY_QTY_ON_HAND: "Quantità a disposizione",
    INVENTORY_SALES: "Vendite",
    SIDEBAR_MENU: "Menu",
    SIDEBAR_OVERVIEW: "Panoramica",
    SIDEBAR_PRODUCTS: "Prodotti",
    SIDEBAR_WAREHOUSE: "Magazzino",
    SIDEBAR_INVENTORY: "Inventario",
    SIDEBAR_ADD_PRODUCT: "Aggiungi prodotto",
    SIDEBAR_GRAPH_VIEW: "Visualizza grafico",
    SIDEBAR_CAMPAIGNS: "Campagne",
    SIDEBAR_CREATE_EDIT_CAMPAIGNS: "Crea/Modifica campagne",
    SIDEBAR_MAP_CAMPAIGNS_PRODUCTS: "Mappa campagne/prodotti",
    SIDEBAR_CUSTOMERS: "Clienti",
    SIDEBAR_ORDERS: "Ordini",
    SIDEBAR_PAYOUTS: "Versamenti",
    SIDEBAR_STAFF_MANAGEMENT: "Gestione staff",
    SIDEBAR_SETTINGS: "Impostazioni",
    SETTINGS_GENERAL_STORE_DETAILS: "Dettagli negozio",
    SETTINGS_GENERAL_STORE_ADDRESS: "    Indirizzo negozio",
    SETTINGS_GENERAL_YOUR_CUSTOMERS_WILL_MESSAGE:
      "I tuoi clienti useranno queste informazioni per contattarti.",
    SETTINGS_GENERAL_STORE_NAME: "Nome negozio",
    SETTINGS_GENERAL_CONTACT_EMAIL: "Email di contatto",
    SETTINGS_GENERAL_ADD_LOGO: "Aggiungi logo",
    SETTINGS_GENERAL_DRAG_AND_DROP: "TRASCINA E RILASCIA",
    SETTINGS_GENERAL_YOUR_FILES_TO_ASSETS: "<span>naviga</span>",
    SETTINGS_ACCEPTED_FILE_TYPE: "Tipi di file accettati: Solo PNG, JPEG. ",
    SETTINGS_ACCEPTED_ADD_HERO_BANNER: "Aggiungi banner hero",
    SETTINGS_ACCEPTED_REMOVE: "Rimuovi",
    SETTINGS_GENERAL_UPLOAD_TERMS_AND_CONDITIONS: "Carica Termini e Condizioni",
    SETTINGS_GENERAL_ENTER_YOUR_TEXT: "Inserisci il testo",
    SETTINGS_GENERAL_STORE_INFORMATION: "Informazioni negozio",
    SETTINGS_GENERAL_SHARE_BIO_LIMIT_CHARACTERS:
      "Condividi biografia (massimo 120 caratteri)",
    SETTINGS_GENERAL_COPY_AND_PASTE_YOUR_MESSAGE:
      "Copia e incolla qui i termini e le condizioni",
    SETTINGS_GENERAL_ENTER_URL_S: 'Inserisci URL"s',
    SETTINGS_GENERAL_WEBSITE_URL: "URL sito web",
    SETTINGS_GENERAL_FACEBOOK_URL: "URL Facebook",
    SETTINGS_GENERAL_INSTAGRAM_URL: "URL Instagram",
    SETTINGS_GENERAL_TWITTER_URL: "URL Twitter",
    SETTINGS_GENERAL_UPLOAD_RETURN_POLICY_HERE:
      "Carica qui la Politica di reso",
    SETTINGS_GENERAL_UPLOAD_SHIPPING_POLICY_HERE:
      "Carica qui la Politica di spedizione",
    SETTINGS_GENERAL_ACTIVE_STATUS: "Stato attivo",
    SETTINGS_GENERAL_PENDING: "In sospeso",
    SETTINGS_GENERAL_APPROVED: "Approvato",
    SETTINGS_GENERAL_LIVE: "Live",
    SETTINGS_GENERAL_DISCARD: "Scarta",
    SETTINGS_GENERAL_SAVE: "Salva",
    SETTINGS_PROFILE_SAVE_PROFILE: "Salva profilo",
    SETTINGS_PROFILE_PREVIEW: "Anteprima",
    SETTINGS_BANKINFO_CONNECT_BANK_ACCOUNT: "Collega conto in banca",
    SETTINGS_BANKINFO_ACCEPT_PAYMENTS_ON_YOUT_MESSAGE:
      "Accetta pagamenti nel tuo negozio usando fornitori di terze parti come Paypal o altri metodi di pagamento",
    SETTINGS_BANKINFO_ADD_BANK_ACCOUNT: "Aggiungi conto in banca",
    SETTINGS_BANKINFO_EDIT: "Modifica",
    SETTINGS_BANKINFO_MANUAL_VERIFICATION: "Verifica manuale",
    SETTINGS_BANKINFO_AT_KWIK_YOUR_SECURITY_MESSAGE:
      "In Kwik siamo molto attenti alla tua sicurezza; per questo verificheremo il tuo conto in banca facendo due piccoli depositi sul tuo conto. Inserisci gli importi che compaiono sul tuo conto",
    SETTINGS_BANKINFO_GO_BACK: "Indietro",
    SETTINGS_BANKINFO_CONTINUE: "Continua",
    SETTINGS_BANKINFO_PLEASE_VERIFY_THE_MESSAGE:
      "Controlla i due piccoli depositi che abbiamo fatto sul tuo conto",
    SETTINGS_BANKINFO_CHARGE1: "Deposito 1",
    SETTINGS_BANKINFO_ENTER_AMOUNT: "Inserisci importo",
    SETTINGS_BANKINFO_CHARGE2: "Deposito 2",
    SETTINGS_BANKINFO_TO_VERIFY_YOUR_MESSAGE:
      "Per verificare il tuo conto in banca, nei prossimi due o tre giorni compariranno due piccoli depositi e prelievi nella lista movimenti. Ognuno sarà inferiore a 1 dollaro",
    SETTINGS_BANKINFO_PLEASE_MAKE_SURE_MESSAGE:
      "Assicurati che sul tuo conto vi siano almeno 2 dollari per evitare di andare in rosso",
    SETTINGS_BANKINFO_BANK_ROUTING_NUMBER: "Routing Number della banca",
    SETTINGS_BANKINFO_ROUTING_NUMBER: "Numero Routing",
    SETTINGS_BANKINFO_ACCOUNT_NUMBER: "Numero di conto",
    SETTINGS_BANKINFO_CONFIRM_ACCOUNT_NUMBER: "Conferma numero di conto",
    SETTINGS_BANKINFO_ACCOUNT_NAME: "Nome conto",
    SETTINGS_BANKINFO_ENTER_ACCOUNT_NAME: "Inserisci nome conto",
    SETTINGS_BANKINFO_SET_YOUR_SHIPPING_RATES: "Imposta tariffe di spedizione",
    SETTINGS_BANKINFO_SET_YOUR_VARIOUS_SHIPPING_RATES:
      "Imposta varie tariffe di spedizione",
    SETTINGS_BANKINFO_ADD_RATE: "Aggiungi tariffa",
    SETTINGS_BANKINFO_ADD_A_NEW_SHIPPING_RATES:
      "Aggiungi una nuova tariffa di spedizione",
    SETTINGS_BANKINFO_PRICING: "Prezzo",
    SETTINGS_BANKINFO_ADD_CONDITIONS: "Aggiungi condizioni",
    SETTINGS_BANKINFO_BASED_ON_ITEM_WEIGHT: "In base al peso del prodotto",
    SETTINGS_BANKINFO_BASED_ON_ORDER_PRICE: "In base al prezzo dell’ordine",
    SETTINGS_BANKINFO_NUMBER_OF_UNITS: "Numero di unità",
    SETTINGS_BANKINFO_SAVE_RATE: "Salva tariffa",
    SETTINGS_BANKINFO_CANCEL: "Annulla",
    SETTINGS_SHIPPINGCOST_SHOW_ALL: "Mostra tutto",
    SETTINGS_SHIPPINGCOST_ADD_SHIPPING_FORMULA:
      "Aggiungi formula di spedizione",
    SETTINGS_SHIPPINGCOST_EDIT_SHIPPING_FORMULA:
      "Modifica formula di spedizione",
    SETTINGS_SHIPPINGCOST_SAVE: "Salva",
    SETTINGS_SHIPPINGCOST_SKU_ID: "ID SKU",
    SETTINGS_SHIPPINGCOST_PRODUCT_NAME: "Nome prodotto",
    SETTINGS_SHIPPINGCOST_DELETE: "Elimina",
    SETTINGS_SHIPPINGCOST_BY_PRICE: "Per prezzo",
    SETTINGS_SHIPPINGCOST_BY_WEIGHT: "Per peso",
    SETTINGS_SHIPPINGCOST_BY_COUNT: "Per numero",
    SETTINGS_SHIPPINGCOST_FROM_PRICE: "Dal prezzo",
    SETTINGS_SHIPPINGCOST_TO_PRICE: "al prezzo",
    SETTINGS_COUNTRY_CODE: "    Codice nazionale",
    SETTINGS_VAT_ID: "    Numero IVA",
    SHIPPINGS_SHIPPINGCOST_FROM_LBS: "Da lbs",
    SHIPPINGS_SHIPPINGCOST_TO_LBS: "A lbs",
    SHIPPINGS_SHIPPINGCOST_FROM_COUNTS: "Da numero",
    SHIPPINGS_SHIPPINGCOST_TO_COUNTS: "A numero",
    SHIPPINGS_SHIPPINGCOST_PLEASE_SELECT_VENDOR: "selezionare venditore!",
    SHIPPINGS_SHIPPINGCOST_PLEASE_SELECT_SHIPPING_METHOD:
      "Selezionare metodo di spedizione",
    SHIPPINGS_SHIPPINGCOST_ITEM_ALREADY_EXISTS: "L’articolo esiste già",
    SHIPPINGS_SHIPPINGCOST_TO_PRICE_CANNOT_BE_ADDED:
      "Al prezzo è #{{unlimited}} e non è possibile aggiungere nuovi dati",
    SHIPPINGS_SHIPPINGCOST_TO_LBS_CANNOT_BE_ADDED:
      "A lbs è #{{unlimited}} e non è possibile aggiungere nuovi dati",
    SHIPPINGS_SHIPPINGCOST_TO_COUNT_CANNOT_BE_ADDED:
      "A numero è #{{unlimited}} e non è possibile aggiungere nuovi dati",
    SHIPPINGS_SHIPPINGCOST_FORMULA_save_successfully:
      "Formula(e) salvata(e) con successo",
    SHIPPINGS_SHIPPINGCOST_DATA_MUST_NOT_BE_EMPTY:
      "I dati non possono rimanere vuoti",
    SHIPPINGS_SHIPPINGCOST_TO_PRICE_DATA_FORMAT_ERROR:
      "Errore di formato dati Al prezzo",
    SHIPPINGS_SHIPPINGCOST_TO_LBS_DATA_FORMAT_ERROR:
      "Errore di formato dati A lbs",
    SHIPPINGS_SHIPPINGCOST_TO_COUNT_DATA_FORMAT_ERROR:
      "Errore di formato dati A numero",
    SHIPPINGS_SHIPPINGCOST_PLEASE_EDIT_UNDER_THE_CORRESPONDING_TYPE:
      "Modificare sotto il tipo corrispondente",
    SHIPPINGS_SHIPPINGCOST_NUMBERS_CAN_NOT_BE_NEGATIVE:
      "i numeri non possono essere negativi",
    CHECKOUT_PAGE_MY_CART: "Carrello",
    CHECKOUT_PAGE_SHIPPING_ADDRESS: "Indirizzo di spedizione",
    CHECKOUT_PAGE_SAVE: "Salva",
    CHECKOUT_PAGE_CHANGE: "Modifica",
    CHECKOUT_FIELD_NAME: "Nome",
    CHECKOUT_FIELD_ADDRESS: "Indirizzo",
    CHECKOUT_FIELD_APT_SUITE_ETC: "App., interno, ecc. (facoltativo)",
    CHECKOUT_FIELD_CITY: "Città",
    CHECKOUT_FIELD_ZIP: "CAP",
    CHECKOUT_FIELD_PROVINCE: "Provincia",
    CHECKOUT_FIELD_STATE: "Regione",
    CHECKOUT_IS_BILLING_ADDRESS_DIFFERENT:
      "L’indirizzo di fatturazione è diverso da quello di spedizione?",
    CHECKOUT_ITEM: "articolo",
    CHECKOUT_ITEMS: "articoli",
    CHECKOUT_PLEASE_FILL_OUT_NAME_FOR_CARD:
      "Si prega di inserire il nome della carta",
    CHECKOUT_TEXT_CHECKOUT: "Acquista",
    CHECKOUT_ENTER_CREDIT_CARD: "Inserisci Carta di credito",
    CHECKOUT_FIRST: "Nome",
    CHECKOUT_LAST: "Cognome",
    CHECKOUT_SAVE_SAVE_TO_MY_ACCOUNT: "Salva la carta nel mio account",
    CHECKOUT_BY_CLICKING_CONFIRM_MESSAGE:
      "Facendo clic su Conferma, si acconsente alla <span>Informativa sulla privacy</span> e al documento di <span>Termini e Condizioni di Kwik</span>",
    CHECKOUT_CONFIRM: "Conferma",
    CHECKOUT_CARD_NUMBER: "Numero carta",
    CHECKOUT_CARD_MM_YY: "MM/AA",
    CHECKOUT_CARD_CVC: "CVV",
    CHECKOUT_BILLING_ADDRESS: "Indirizzo di fatturazione",
    CHECKOUT_SAVE_ADDRESS: "Salva indirizzo",
    CHECKOUT_SAVE_SUCCESS: "Indirizzo salvato con successo!",
    CHECKOUT_SAVE_FAILED:
      "Si prega di compilare il modulo seguente. Tutti i campi sono obbligatori",
    SHARING_PRO_YOU_CAN_SHARE: "Prodotti da condividere",
    SHARING_UWTTEE: "Usa le Onde Tech per guadagnare in modo esponenziale",
    SHARING_UWTTEE_DESC:
      "Lo strumento per scatenare il tuo vero potenziale di guadagno online e massimizzare la tua reale influenza. Usa uno dei link seguenti per mettere alla prova la tecnologia di Onde Kwik  e guadagnare per la tua reale influenza.",
    SHARING_CLOSE: "Chiudi",
    SHARING_FIVE_TIMES: "Lo vedrai solo altre cinque volte",
    SHARING_SHARE_FULL_CAMP: "Condividi l’intera campagna",
    SHARING_SINGLE_PRO: "Condividi un singolo prodotto",
    SHARING_MOST_SHARED: "Link più condiviso da",
    ALL_PRO_POLICIES: "Politiche",
    SS_THANK_YOU: "Grazie",
    SS_SHARE_TIPS:
      "Ti piace il tuo acquisto? Fantastico. Perché non guadagnare per averlo condiviso con un amico?",
    SS_SHARE_TIPS_DESC:
      "Crea un account e inizia a condividere i tuoi KwikLink! Il tuo link tiene traccia degli acquisti effettuati dai tuoi amici e parenti, così le commissioni per i referral vengono depositate direttamente nel tuo account Kwik.",
    SS_CUSTOMER_INFO: "Informazioni sul cliente",
    SS_ADDRESS_INFO: "Indirizzo",
    SS_CHECK_YOUR_EARNING: "Controlla i tuoi guadagni!",
    SS_WHMIETSYA: "Impostare un account è davvero semplice!",
    SS_RETURN_HOME: "Ritorna a Home",
    SS_CREATE_HOME: "Crea account",
    SS_NEWAGE_PV: "PV NewAge",
    SS_FOOTER_HEAR_YOU: "Vogliamo sentire la tua opinione!",
    SS_FOOTER_EMAIL: "support@wer1.com",
    SS_FOOTER_PPTOU: "Informativa sulla privacy | Termini di utilizzo",
    SS_FOOTER_COPY_RESERVED: "Copyright. ©2023 Tutti i diritti riservati",
    SS_FOOTER_HOME: "Home",
    SS_FOOTER_HOW_IT_WORKS: "Come funziona",
    SS_FOOTER_FOR_BRANDS: "Per i brand",
    SS_FOOTER_WHAT_NEW: "Novità",
    SS_FOOTER_HELP_SUPPORT: "Aiuto & Assistenza",
    SS_FOOTER_PRIVACY_POLICY: "Informativa sulla privacy",
    SS_TERMS_OF_USE: "Termini di utilizzo",
    SS_FOOTER_SUB_FOR_UPDATES: "Iscriviti per ricevere gli aggiornamenti",
    SS_FOOTER_FOLLOW_US: "SEGUICI",
    SS_SUCESS: "Condivisione effettuata",
    SS_REGISTER_YSSYP:
      "Hai condiviso con successo un prodotto. È ora di creare un account per gestire i tuoi guadagni!",
    SS_REGISTER_BSUFAK:
      "Registrando un account Kwik accetto tutti i Termini e le Condizioni esposte di seguito.",
    SS_REGISTER_YAAD: "Ci sei quasi!",
    SS_REGISTER_WHSAVCT:
      "Abbiamo inviato un codice di verifica all’indirizzo email che hai usato in fase di acquisto. Se vuoi ricevere un altro codice, fai clic su Invia di nuovo.",
    LEGAL_INFO: "Informazioni legali",
    LEGAL_WELCOME_TO_KWIK: "Benvenuto su WeR1!",
    LEGAL_TC: "Termini e Condizioni",
    HEADER_MENU_SHARING: "Condivisione",
    HEADER_MENU_SHOPPING: "Acquisti",
    HEADER_MENU_HELP: "Aiuto",
    HEADER_MENU_ACCOUNT_SETTING: "Impostazioni account",
    HEADER_LAYER_ACCOUNT: "Account",
    HEADER_LAYER_EDIT_ACCOUNT: "Modifica account",
    HEADER_LAYER_LOGOUT: "Esci",
    HEADER_LAYER_HELP_CONTACT: "Aiuto/Contatti",
    HEADER_LAYER_HELP_LEGAL: "Legale",
    HEADER_LAYER_HELP_LANGUAGE: "Lingua",
    HEADER_LAYER_HELP_SELECT_YOUR_GEOGRAPHICAL_REGION:
      "Seleziona la tua regione geografica",
    HEADER_LAYER_HELP_SELECT_YOUR_PREFERRED_LANGUAGE:
      "Seleziona la tua lingua preferita",
    SETTING_HEADER_ACCOUNT: "Account",
    SETTING_HEADER_HELP_CONTACT: "Contatti Aiuto",
    SETTING_HEADER_LEGAL: "Legale",
    SETTING_HEADER_SETTINGS: "Impostazioni",
    SETTING_ACCOUNT_CHANGE_IMAGE: "Cambia immagine",
    SETTING_ACCOUNT_FIRST_NAME: "Nome",
    SETTING_ACCOUNT_FIRST_NAME_IS_REQUIRED: "Il campo Nome è obbligatorio",
    SETTING_ACCOUNT_LAST_NAME: "Cognome",
    SETTING_ACCOUNT_LAST_NAME_IS_REQUIRED: "Il campo Cognome è obbligatorio",
    SETTING_ACCOUNT_USER_NAME: "Nome utente",
    SETTING_ACCOUNT_USER_NAME_IS_REQUIRED:
      "Il campo Nome utente è obbligatorio",
    SETTING_ACCOUNT_PROFILE_CONTACT_INFO: "Info di contatto del profilo",
    SETTING_ACCOUNT_PHONE_NUMBER: "Numero di telefono",
    SETTING_ACCOUNT_PHONE_NUMBER_IS_REQUIRED:
      "Il campo Numero di telefono è obbligatorio",
    SETTING_ACCOUNT_EMAIL: "Email",
    SETTING_ACCOUNT_EMAIL_IS_REQUIRED: "Il campo Email è obbligatorio",
    SETTING_ACCOUNT_PLEASE_NOTE_MESSAGE:
      "Nota: questa è la modalità di contatto dalla pagina di Profilo. Aggiorna queste informazioni così le persone sapranno come mettersi in contatto con te.",
    SETTING_ACCOUNT_YOUR_LOGIN_EMAIL_MESSAGE:
      "Il tuo indirizzo email di accesso e il numero di telefono resteranno gli stessi.",
    SETTING_ACCOUNT_SECURITY: "Sicurezza",
    SETTING_ACCOUNT_PASSWORD: "Password",
    SETTING_ACCOUNT_DISCARD: "Scarta",
    SETTING_ACCOUNT_CHANGE_PASSWORD: "Cambia password",
    SETTING_CONTACT_HELP_CONTACT: "Aiuto & Contatti",
    SETTING_CONTACT_CONTACT_US_AT: "Contattaci a",
    SETTING_CONTACT_ADDRESS: "Indirizzo",
    SETTING_CONTACT_EMAIL: "Email",
    SETTING_CONTACT_PHONE: "Telefono",
    SETTING_CONTACT_WHAT_TYPE_OF_PROBLEM: "Tipo di problema",
    SETTING_CONTACT_PROBLEM_IS_REQUIRED: "Il campo Problema è obbligatorio",
    SETTING_CONTACT_THIS_FIELD_IS_REQUIRED: "Questo campo è obbligatorio",
    SETTING_CONTACT_PLEASE_GIVE_US_DETAILS_MESSAGE:
      "Ti preghiamo di fornirci i dettagli del problema che stai riscontrando. Nome, indirizzo email e numero ordine se pertinenti.",
    SETTING_CONTACT_DETAIL_IS_REQUIRED: "Il campo Dettagli è obbligatorio",
    SETTING_CONTACT_ATTACH_ANY_IMAGES_MESSAGE: "Allega immagini o screenshot",
    SETTING_CONTACT_DRAG_AND_DROP_MESSAGE:
      "Trascina e rilascia un file video negli asset o sfoglia",
    SETTING_CONTACT_SUBMIT: "Invia",
    SORRY_YOU_CAN_T_SHARE_PRODUCT_MESSAGE:
      "Siamo spiacenti, non puoi condividere il prodotto #{{names}}. Acquista subito questo prodotto o fai domanda di idoneità.",
    USER_REGISTER_INVLID_INPUT_CHARACTERS: "    Caratteri immessi non validi",
    CHECKOUT_PAYMENT: "    Pagamento",
    ADD_PRODUCT_RETAIL: "    Prezzo al dettaglio",
    ADD_PRODUCT_WHOLESALE: "    Prezzo all’ingrosso",
    ADD_PRODUCT_PLEASE_INPUT_YOUR_WHOLESALE:
      "    Inserisci il prezzo all’ingrosso!",
    ADD_PRODUCT_RETAIL_SHOULD_NOT_MESSAGE:
      "    Il prezzo all’ingrosso deve essere inferiore a quello al dettaglio",
    ADD_PRODUCT_PROMOTIONAL_INSTANT_KWIK_CASH_ACCRUAL:
      "    Accumulo istantaneo e promozionale di KwikCash",
    ADD_PRODUCT_OF_RETAIL: "    di prezzo al dettaglio",
    ADD_PRODUCT_BRAND_PAYOUT:
      "    Payout del marchio (prezzo all’ingrosso adeguato)",
    ADD_PRODUCT_KWIK_REVENUE: "    Entrate di Kwik",
    ADD_PRODUCT_OF_DELTA: "    di Delta",
    ADD_PRODUCT_ADMINISTRATION_FEE: "    Tariffa amministrativa",
    ADD_PRODUCT_REFERRAL_FEE: "    Tariffa di referral",
    ADD_PRODUCT_INSTANT_KWIK_CASH_ACCRUAL:
      "    Accumulo istantaneo di KwikCash",
    ADD_PRODUCT_COMMISSION_ALLOCATION: "    Allocazione commissioni",
    ADD_PRODUCT_TRUE_COMMISSION_ALLOCATION: "    Allocazione commissioni reali",
    ADD_PRODUCT_LEVEL_WAVE_OF_COMMISSION: "    {{level}} Onda di commissioni",
    VENDOR_SETTINGS_BRAND_ID: "    ID marchio",
    VENDOR_SETTINGS_KWIK_REVENUE: "    Entrate di Kwik(%)",
    VENDOR_SETTINGS_ADMIN_FEE: "    Tariffa amministrativa(%)",
    VENDOR_SETTINGS_RETAIL_MULTIPLLER: "    Moltiplicatore prezzo al dettaglio",
    VENDOR_SETTINGS_FEE_MULTIPLLER: "    Moltiplicatore tariffa",
    VENDOR_SETTINGS_REFERRAL_FEE: "    Tariffa di referral(%)",
    VENDOR_SETTINGS_IKCA: "    Accumulo istantaneo di KwikCash(%)",
    VENDOR_SETTINGS_REFERRAL_EMAIL: "    Email del referral",
    VENDOR_SETTINGS_TP: "    Promozione temporanea(%)",
    VENDOR_SETTINGS_NEWAGE_CAMPAIGN: "    Coinvolgimento brand NewAge",
    VENDOR_SETTINGS_FULL_BY_NEWAGE: "    Completato da NewAge",
    VENDOR_SETTINGS_CTPV: "    Percentuale commissioni sul valore di PV(%)",
    VENDOR_SETTINGS_DPP: "    Dollari per PV",
    PRODUCTS_DETAIL_VENFOR_PAYOUT: "    Payout venditore",
    PRODUCTS_DETAIL_PAYOUT_REMITTENCE: "    Pagamento payout",
    PRODUCTS_DETAIL_CASHBACK_STRUCTRUE: "    Struttura cashback",
    PRODUCTS_DETAIL_CASHBACK: "    Cashback",
    PRODUCTS_DETAIL_PROMOTIONAL_CASHBACK: "    Cashback promozionale",
    PRODUCTS_DETAIL_WAVE_COMM_STRUCTURE: "    Struttura commissioni onda",
    PRODUCTS_DETAIL_WAVE_COMM_STRUCTURE_DESC:
      "    Determinato dal Prezzo al dettaglio - Prezzo all’ingrosso. Regolarli per vedere un cambiamento nella struttura di onda",
    PRODUCTS_DETAIL_TOTAL_WAVE_FUNDING: "    Finanziamento onda totale",
    PRODUCTS_DETAIL_1ST_OF_RETAIL: "    1a Onda come % di prezzo al dettaglio",
    PRODUCTS_DETAIL_TEMPORARY_PROMOTIONS: "    Promozioni temporanee",
    PRODUCTS_DETAIL_OPTIONAL: "    Facoltativo",
    PRODUCTS_DETAIL_TPR: "    Pagamento Temporaneo - Payout",
    PRODUCTS_DETAIL_SALES_CHANNEL: "    Canale vendita",
    PRODUCTS_DETAIL_SALES_CHANNEL_DESC:
      "    Si noti che questi canali aggiuntivi sono facoltativi. Se ne scegli uno, questo può influenzare le varie quantità di onde.",
    PRODUCTS_DETAIL_DIRECT_DISTRIBUTE: "    Distribuzione diretta",
    VENDOR_SETTINGS_WRONG_TYPE: "    Inserire il tipo di numero",
    PRODUCTS_DETAIL_TAX_VAT_DUTY: "    Tasse/IVA/Imposte",
    PRODUCTS_DETAIL_REQUIRE_EU: "    - Richiesto per i Paesi UE",
    PRODUCTS_DETAIL_REQUIRE_AUS: "    - Richiesto per l’Australia",
    PRODUCTS_DETAIL_REQUIRE_CAN:
      "    - Richiesto per l’e-commerce transnazionale del Canada",
    SHARE_LINK_PRICE_VAT: "    IVA",
    LEGAL_CONTENT:
      "Benvenuto su Kwik!  \nKwik è un mercato esclusivo dove puoi vendere, comprare, condividere e guadagnare attraverso la tua capacità di influenza online. Vogliamo che tutti coloro che visitano il nostro sito e utilizzano i nostri Prodotti vivano un’esperienza positiva. Tra i nostri Prodotti annoveriamo il nostro sito web, la nostra app per smartphone e molto altro ancora.\nIl presente documento è un contratto legalmente vincolante tra te e Kwik. Utilizzando i Prodotti di Kwik l’utente accetta le seguenti Condizioni, ossia le nostre regole che permettono a tutti di godere della migliore esperienza possibile. Se l’utente non accetta queste condizioni, non può utilizzare i Prodotti di Kwik.  \nSi ricorda che le presenti Condizioni non hanno lo scopo di creare un rapporto di collaborazione, joint venture, lavoro dipendente o franchising tra l’utente e Kwik.\nSe l’utente è interessato a Vendere tramite Kwik deve inoltre comprendere e accettare la nostra Politica per il venditore\nIl conto dell’utente\nPer utilizzare i nostri Prodotti, l’utente deve creare un conto. Fare clic qui per scoprire come configurare un conto su Kwik. Creando un conto, l’utente accetta le condizioni seguenti:\nÈ ammesso un solo conto per persona. L’utente è responsabile del proprio conto\nL’utente deve avere un’età pari o superiore a 18 anni. I ragazzi di età superiore a 13 anni possono usare Kwik solo attraverso il conto di un genitore o di un tutore legale. L’utente è responsabile di qualsiasi utilizzo dei servizi da parte di un minore sul conto dell’utente. I ragazzi di età inferiore ai 13 anni non sono autorizzati a usare i nostri Prodotti.\nLe informazioni fornite dall’utente su se stesso devono essere veritiere e precise. È vietato assumere l’identità di un’altra persona o società sul proprio conto.\nL’utente è responsabile di proteggere il conto e la propria password.\nUso dei Prodotti di Kwik\nUtilizzando i Prodotti di Kwik, l’utente dichiara di avere compreso e accettato le condizioni riportate di seguito. Durante l’uso di Kwik, l’utente è tenuto a:\nNon accedere ai dati dei Prodotti di Kwik usando robot, spider o altri mezzi automatizzati a cui non si è autorizzati ad accedere\nNon raccogliere, copiare, utilizzare, trasferire o vendere dati dei prodotti di Kwik che non sono stati forniti all’utente da Kwik\nNon caricare un link non autorizzato su un sito esterno\nNon caricare o contribuire a caricare l'introduzione di qualsiasi codice maligno o virus sui Prodotti di Kwik\nNon commettere alcuna azione che violi i diritti di terzi, compresi i diritti di proprietà intellettuale\nNon compromettere il funzionamento corretto dei prodotti di Kwik\nNon violare le leggi locali o internazionali, i marchi commerciali, i diritti o i diritti di proprietà intellettuale \nRispettare la nostra Politica sui marchi commerciali\nPagare tutte le commissioni spettanti a Kwik\nContenuto\nDurante l’uso di Kwik, l’utente avrà molte opportunità per creare contenuti. Il contenuto prodotto dall’utente comprende, a titolo esemplificativo ma non esaustivo, revisioni, commenti, foto, immagini del profilo, descrizioni sul profilo e messaggi ai Venditori. L’utente è responsabile del contenuto che pubblica o carica sul proprio conto.\nPer garantire un’esperienza positiva a tutti i membri di Kwik, la pubblicazione di determinati tipi di contenuto è vietata sui Prodotti di Kwik. Utilizzando i nostri Prodotti, l’utente accetta di non produrre contenuti che promuovano odio, abuso, minacce, volgari, osceni, falsi, fuorvianti o in alcun modo ingannevoli. \nKwik si impegna a proteggere i diritti di proprietà intellettuale. Se l’utente carica o pubblica contenuti che violano la proprietà intellettuale di una terza parte, intraprenderemo le azioni necessarie. Queste comprendono la disabilitazione temporanea del conto o l’eliminazione del conto dell’utente se questi utilizza o viola ripetutamente la proprietà intellettuale di terzi. Qualora ciò dovesse verificarsi, daremo comunicazione di tali modifiche. Se il contenuto di cui sei proprietario o su cui hai diritti è stato pubblicato senza autorizzazione, contatta Kwik.\nSe sei un Venditore, consulta la nostra Politica per il venditore per maggiori informazioni sui nostri Regolamenti.\nPrivacy degli utenti\nCi impegniamo a proteggere la privacy e le informazioni personali degli utenti. Di seguito descriviamo quali informazioni personali raccogliamo noi di Kwik e come vengono utilizzate. Se l’utente non vuole che Kwik utilizzi le informazioni secondo le modalità descritte di seguito, non deve utilizzare i Prodotti di Kwik.\nKwik può ottenere informazioni fornite volontariamente dall’utente. Per utilizzare i Prodotti di Kwik e creare un conto, l’utente deve fornire un indirizzo e-mail valido e un nome che verrà associato al suo conto.  Può scegliere di fornire altre informazioni sul suo conto, come il compleanno, la biografia, la posizione o il sesso. È altresì possibile lasciare recensioni sui prodotti o altri commenti. Queste informazioni saranno disponibili ad altri visitatori e membri di Kwik.\nSe l’utente guadagna onde (o Kwik Cash) deve fornire informazioni finanziarie aggiuntive (ad esempio, numero della carta di credito e del conto, dettagli della transazione e metodo di pagamento). Se l’utente ha intenzione di vendere attraverso Kwik, si prega di consultare la nostra Politica per il venditore per scoprire quali informazioni aggiuntive occorre fornire a Kwik per verificare l’identità dell’utente e le informazioni finanziarie per beneficiare delle vendite.\nQuando l’utente pubblica contenuti sui Prodotti di Kwik concede a Kwik l’autorizzazione a utilizzare tali contenuti. Non rivendichiamo mai la proprietà del contenuto. Utilizziamo e condividiamo i contenuti pubblicati dai Venditori per promuovere i prodotti del Venditore ad altri Venditori e Acquirenti in base ai loro elenchi, ricerche e uso dei Prodotti di Kwik. Questo permesso consente altresì a Kwik di apportare eventuali modifiche ai contenuti, ad esempio migliorare o ridimensionare una foto, tradurre il contenuto in diverse lingue a seconda delle esigenze.\nKwik raccoglie inoltre automaticamente le informazioni quando l’utente utilizza i nostri Prodotti, compreso il nostro Sito e la nostra App per smartphone. Tra queste si annoverano l’indirizzo IP, altri identificativi univoci del dispositivo o la versione dell’app utilizzata. Queste informazioni possono aiutarci a evitare truffe ai danni degli utenti. Kwik raccoglie automaticamente anche dati sull’utilizzo del sito da parte dell’utente, come ad esempio le pagine visitate e la modalità di interazione con queste pagine (i clic su un link o la durata della visita su una pagina). Questo ci permette di personalizzare l’esperienza dell’utente e facilitare le comunicazioni pubblicitarie in base agli interessi degli utenti.\nKwik e i Venditori raccolgono le informazioni personali e sono entrambi titolari del trattamento dei dati. Quando si acquista un articolo su Kwik, l’utente fornisce informazioni anche ai Venditori, ivi compresi il nome, l’indirizzo, l’indirizzo di fatturazione e informazioni sul pagamento. I Venditori devono adempiere alle regole per la tutela della privacy dell’acquirente, come indicati nella nostra Politica per il venditore. All’atto del pagamento, possiamo memorizzare le informazioni della carta di credito, l’indirizzo di fatturazione e altre informazioni necessarie per l’elaborazione dell’operazione e per la fatturazione e pagamento. I membri di alcuni paesi possono consentire a Kwik di ricordare queste informazioni al fine di semplificare gli acquisti futuri.\nAltre informazioni potrebbero essere fornite dall’utente quando contatta l’assistenza clienti. \nGuadagnare Kwik Cash\nGli influencer possono guadagnare Kwik Cash quando acquistano un prodotto, condividono un link esclusivo a quel prodotto sui social network, quel link ottiene dei clic per visitare la pagina e viene finalizzata una vendita. Affinché l’influencer possa guadagnare Kwik Cash, l’influencer DEVE acquistare il prodotto e la vendita deve essere effettuata utilizzando il link fornito dall’influencer. Come specificato sopra, l’utente dovrà fornire informazioni aggiuntive comprese le informazioni finanziarie per poter ricevere il Kwik Cash.\nNegli Stati Uniti, sede operativa di Kwik, gli influencer devono adempiere alla Disclosure of Material Connection della Federal Trade Commission (FTC) [link]. Questo è necessario quando il rapporto di committenza (come il pagamento, un prodotto o un servizio gratuiti o una sponsorizzazione) potrebbero compromettere la credibilità dell’endorsement dell’influencer (ad esempio, l’endorsement sarebbe solamente positivo in ragione del beneficio dell’influencer) o quando il pubblico non se lo aspetta perché non vi è un collegamento esplicito al Brand.\nPer guadagnare Kwik Cash, gli Influencer devono adempiere alle seguenti regole:\nL’influencer deve dichiarare chiaramente che sussiste un rapporto di committenza nei confronti di prodotti, merci o servizi di un Venditore. Di seguito riportiamo alcuni esempi di come dichiarare tale rapporto:\nDichiarazione: cliccando su questo link e acquistando [prodotto del Brand] su Kwik, guadagnerò Kwik Cash.\nHashtag chiaramente visibili #pubblicità, #sponsorizzato, #ad[Brand] o #ad\nLa dichiarazione deve trovarsi all’interno del post dell’influencer inerente al prodotto ed essere chiaramente visibile.\nL’influencer deve essere onesto e non fuorviante in merito al prodotto.\nL’influencer non può rilasciare dichiarazioni mendaci sul prodotto, comprese vere e proprie falsità, testimonianze non rappresentative (come, ad esempio, un effetto di un prodotto che non si verifica su tutti gli acquirenti, vale a dire “questa crema per il viso mi fa sembrare più giovane di cinque anni”) o dichiarazioni non comprovate (l'influencer non ha un'esperienza adeguata con il prodotto per avallarlo).\nAgli utenti che risiedono al di fuori degli Stati Uniti, si applicano leggi analoghe. I residenti in Canada devono prendere visione del Competition Act [link] ai sensi del Competition Bureau e delle penali per la violazione delle norme che disciplinano l’attività degli influencer. I residenti nel Regno Unito devono prestare attenzione alle norme che disciplinano l’attività degli influencer sui social network approvate dalla Advertising Standards Authority (ASA), dal Committee of Advertising Practice (CAP) e dalla Competition and Markets Authority (CMA). [link] L’utente è responsabile di prendere atto delle leggi vigenti nel proprio paese di residenza e di utilizzare la sua capacità di condizionamento online di conseguenza.\nPolizza di esclusione 401(k)\nQuando l’utente guadagna Kwik Cash, è consapevole che Kwik non offre e non è responsabile di offrire un piano 401(k) poiché l’utente non è dipendente di Kwik.\nPolitica sulle controversie\nPolitica sulla segnalazione \nSe l’utente ha un problema con un prodotto, è pregato di contattare prima il Venditore direttamente per risolvere la questione. Se il Venditore non risponde o non risolve il problema, l’utente può aprire una segnalazione su Kwik. \nÈ possibile aprire una segnalazione se un articolo viene consegnato e risulta non corrispondente alla descrizione o all’immagine riportate nello shop del Venditore o se non viene consegnato a causa di azioni intraprese dal Venditore. L’Acquirente deve fornire una foto per un articolo che si sostiene non corrispondente alla descrizione o all’immagine riportate nello shop del Venditore. Alcuni esempi possono riguardare un/gli articolo/i che è/sono \nRealizzati in materiale o composizione diversa da quanto descritto\nDi diverse dimensioni, colore, modello o versione\nIn condizioni diverse da quelle descritte (ossia, descritto come nuovo ma in realtà è usato)\nIn quantità diversa rispetto a quella ordinata\nDanneggiato/i \nPrivi di pezzi o parti\nForniti incompleti di servizi previsti\nIl Venditore deve inviare un prodotto acquistato entro un periodo di tempo ragionevole o soddisfare una data di consegna prevista. Tuttavia, non è possibile aprire una segnalazione se l’articolo è danneggiato, non consegnato o consegnato in ritardo a causa della spedizione da parte di terzi, poiché né il Venditore né Kwik sono responsabili. \nLe segnalazioni saranno risolte quando\nL'acquirente riceve un rimborso.\nL'acquirente chiude la segnalazione.\nQuando viene aperta una segnalazione per mancata consegna e il Venditore dimostra che il prodotto è stato inviato puntualmente all’indirizzo dell’acquirente.\nPer maggior informazioni sulle responsabilità del Venditore, consultare la nostra Politica per il venditore.\nControversie con terze parti\nQuando si verifica un problema riguardo a un prodotto o un’interazione con un Venditore o un altro membro di Kwik, si raccomanda di seguire i passaggi elencati sopra nella nostra Politica sulla segnalazione. Faremo tutto il possibile per aiutarvi a risolvere qualsiasi problema relativo alle nostre politiche. Tuttavia, non siamo tenuti a risolvere controversie tra gli utenti e altri membri di Kwik o terze parti. L’utente solleva Kwik da qualsiasi reclamo, danno o richiesta derivante da controversie con altri membri o altre parti. \nControversie con Kwik\nChe si tratti di un Venditore o di un Acquirente, se l’utente ha una controversia con noi, è pregato di contattarci immediatamente e ci impegneremo al meglio per risolvere il problema. Se non è possibile risolvere la controversia con la nostra assistenza clienti, la preghiamo di consultare le nostre politiche di procedura sotto riportate.\nLegge vigente\nLe presenti Condizioni sono disciplinate dalle leggi degli Stati Uniti. Se l’utente vive al di fuori degli Stati Uniti può essere protetto dalle leggi vigenti sulla tutela dei consumatori previste dal Codice del consumo.\nIn caso di problemi con noi, gli utenti sono pregati di contattarci e ci impegneremo a risolvere il problema. Se tuttavia non è possibile trovare una risoluzione, le seguenti regole disciplineranno eventuali controversie legali con Kwik e i relativi Prodotti.\nArbitrato\nUtilizzando i nostri servizi, l’utente accetta di risolvere tutte le controversie con Kwik tramite arbitrato individuale vincolante. Ciò significa che le controversie sono gestite da un arbitrato e non deliberate da un giudice o una giuria. L’utente rinuncia a qualsiasi diritto di partecipare a un’azione di classe, un arbitrato collettivo o ad azioni collettive. (Gli arbitrati di classe sono disponibili solo se richieste da entrambe le parti ai sensi delle Class Action Arbitration Rules e approvati dall’arbitro). L’arbitrato sarà amministrato dall’American Arbitration Association, “AAA”, ai sensi delle Consumer Arbitration Rules, “Regole di AAA”, in vigore al momento, se non diversamente previsto dalla legge. Ciascuna parte ha facoltà di intentare un'azione in tribunale avente competenza dopo la decisione finale dell’arbitrato o del mediatore.\nIn luogo dell’arbitrato l’utente può avanzare le proprie pretese in tribunali per le controversie di modesta entità, se del caso. Il caso in questione deve essere presentato individualmente e non attraverso un’azione di classe o collettiva. La Federal Arbitration Act e le leggi vigenti stabiliranno l'interpretazione e l’impugnabilità giuridica delle presenti Condizioni. \nLe Consumer Arbitration Rules di AAA determineranno pagamenti per qualsiasi deposito da parte di AAA, ivi comprese le commissioni amministrative e di arbitrato. Se il valore della pretesa non supera USD 10.000, Kwik pagherà le spese ragionevoli amministrative, di deposito e dell’arbitro associate all’arbitrato. Se tuttavia l’arbitro stabilisce che la pretesa o la domanda giudiziale dell’utente sia futile o sia stata presentata per uno scopo improprio, Kwik non sarà responsabile del pagamento. \nLimitazione di responsabilità\nQuando l’utente utilizza i Prodotti di Kwik, accetta di mantenere Kwik indenne per quanto segue: \nArticoli acquistati e utilizzo degli articoli \nQuando l’utente acquista un articolo sui Prodotti di Kwik, riconosce e prende atto di non acquistare un articolo da Kwik. Gli articoli pubblicati e venduti tramite i Prodotti di Kwik provengono da Venditori indipendenti. In caso di problemi con un articolo, si prega di contattare il Venditore o aprire una Segnalazione su Kwik seguendo le istruzioni riportate sopra. \nKwik non è responsabile di eventuali conseguenze derivanti dall’uso dell’articolo. Se l’uso corretto o improprio di un articolo provoca lesioni o danni personali all’articolo, l’utente accetta di non ritenere Kwik responsabile.  \nSiti web o servizi di terze parti\nI Contenuti di Venditori e dei membri di Kwik possono comprendere link a siti, servizi, pagine di social network di terze parti o altri mercati online. L’utente riconosce che questi non sono controllati né influenzati da Kwik. Molti di questi siti web e servizi ha le proprie Condizioni che l’utente accetta e a cui sarà vincolato ed è responsabilità dell’utente esserne a conoscenza. Analogamente, l’utente accede ai Prodotti di Kwik usando un dispositivo come, ad esempio, un telefono cellulare, e anche questo non è associato a Kwik.\nContenuti e interazioni con i membri\nIn quanto membro di Kwik, l’utente può condividere contenuti tramite il proprio profilo lasciando una recensione o inviando un messaggio. Abbiamo a cuore l’esperienza degli utenti ed è per questo motivo che chiediamo ai membri di rispettare i nostri Regolamenti. Eventuali contenuti pubblicati da un membro di Kwik, tuttavia, non rispecchiano Kwik e noi non ci assumiamo alcuna responsabilità sui contenuti pubblicati. Kwik non è responsabile per la legittimità, della precisione alla conformità al copyright o della conformità ai nostri standard di qualsiasi contenuto pubblicato dai membri a cui si accede attraverso i nostri Prodotti. L’utente solleva Kwik da tutte le responsabilità relative ai contenuti pubblicati dai membri.\n Kwik non è responsabile delle interazioni degli utenti con altri individui tramite Kwik. I membri possono aprire Segnalazioni in caso di prodotti danneggiati o non consegnati, e Kwik chiuderà il conto che viola determinate regole (si veda sotto), ma invitiamo gli utenti a comprendere che non effettuiamo controlli sugli utilizzatori dei nostri Prodotti. L’utente solleva Kwik da tutte le responsabilità relative alle interazioni con altri utenti. In tutte le interazioni con altri utenti su Kwik o su altre piattaforme si prega di usare buon senso e prudenza. Ad esempio, non è una buona idea accettare di incontrare di persona un utente che si è conosciuto online.\nIndennizzo \nNel raro caso in cui Kwik venga citata in giudizio a causa delle azioni, dell’uso o dell’uso improprio dei nostri Prodotti, della violazione delle presenti Condizioni o dei diritti di terze parti da parte di un utente, tale utente accetta di risarcire Kwik. Questo significa che l’utente difenderà noi o ci manterrà indenni (compresi i dipendenti, gli affiliati e le consociate) da qualsiasi pretesa o richiesta, ivi comprese le spese legali. \nCi riserviamo il diritto di gestire la nostra difesa legale nei modi da noi ritenuti opportuni. Questo comprende l’indennizzo a carico del cliente qualora accetti di collaborare.\nModifiche alle Condizioni per l’utente \nComunicheremo agli utenti eventuali modifiche sostanziali alle nostre Condizioni 30 giorni prima dell’entrata in vigore. Continuando a utilizzare i Prodotti di Kwik, l’utente accetta tutti gli aggiornamenti. Se l’utente non accetta eventuali modifiche alle nostre condizioni, può inviare a Kwik un avviso scritto oppure chiudere il conto prima che i cambiamenti entrino in vigore.\nControversie relative alle modifiche\nCome accade per tutte le modifiche e i cambiamenti alle nostre Condizioni, all’utente verrà comunicato e potrà decidere se accettare le modifiche o rifiutarle chiudendo il proprio conto. Se l’utente rifiuta gli aggiornamenti alle Condizioni e ha una controversia con Kwik, accetta di risolvere la controversia tramite arbitrato ai sensi della nostra Politica sulle controversie, ivi comprese eventuali modifiche effettuate prima del rifiuto. Qualora apportassimo modifiche alla Politica sulle controversie dopo la data dell’ultima accettazione dell’utente delle Condizioni, compreso l’uso continuativo dei nostri Prodotti dopo la comunicazione delle modifiche, tali modifiche non si applicano alle pretese presentate in azione legale contro Kwik prima della data di entrata in vigore delle modifiche. Se l’utente chiude un conto poi lo riapre, accetta la versione corrente delle presenti Condizioni.\nChiusura del conto\nLa chiusura del conto dell’utente può avvenire in due modi: per azione dell’utente o per nostra azione. L’utente può chiudere il conto in qualsiasi momento dalle impostazioni del conto. Se l’utente chiude il conto, i contenuti che ha creato e pubblicato (commenti, revisioni o foto caricate) rimarranno sui Prodotti di Kwik. Si fa presente che si potrebbero perdere altre informazioni associate al conto.\nPossiamo sospendere o chiudere il conto se abbiamo motivo di ritenere che l’utente abbia violato le presenti Condizioni durante l’uso dei Prodotti di Kwik. Se ciò accade, si ricorda che l’utente non ha alcun diritto legale o contrattuale per continuare a utilizzare i nostri Prodotti. Ad esempio, dopo la chiusura del conto, non è possibile acquistare o vendere sulla nostra piattaforma online. Fatto salvo il caso in cui l’utente abbia violato ripetutamente le nostre Condizioni o non abbiamo ragioni legali o di politica per astenerci, comunicheremo all’utente eventuali cambiamenti al conto.\nKwik si riserva il diritto di interrompere, sospendere o modificare i propri Prodotti e il metodo di interazione con essi. Utilizzando i nostri Prodotti, l’utente prende atto che Kwik non è responsabile degli effetti di eventuali cambiamenti o interruzioni dei nostri Prodotti. \nLe presenti Condizioni rimangono in vigore dopo la chiusura del conto.\nAltre questioni legali \nLe presenti Condizioni sostituiscono qualsiasi altro accordo che l’utente può avere stipulato con Kwik. Se qualche parte delle Condizioni non è impugnabile, quella parte sarà limitata nella misura minima necessaria e le Condizioni rimarranno in vigore appieno. Se non impugniamo immediatamente eventuali parti delle presenti Condizioni, l’utente riconosce che Kwik si riserva il diritto di impugnarle in un secondo momento.\nDomande sulle Condizioni  \nIn caso di domande sulle presenti Condizioni, si prega di contattare l’assistenza clienti all’indirizzo support@wer1.com.",
    SHARELINK_PRODUCT_DETAIL_NO_DATA:
      "Questo prodotto non è disponibile nel tuo paese!",
    VENDOR_SHIPPING_COST_SHIPPING_METHODS: "Metodo di spedizione",
    CHECKOUT_SAVE_SHIPPING_ADDRESS_MESSAGE: "Compila il modulo seguente",
    SORRY_YOUR_PAYMENT_DID_NOT_GO_THROUGH:
      "Non siamo riusciti a elaborare il pagamento. Si prega di riprovare.",
    ORDER_HISTORY_ORDER_MORE: "Ordina di più",
    ORDER_HISTORY_SHARE_PRODUCT: "Condividi prodotto",
    ORDER_HISTORY_EDIT_REVIEW: "Modifica una recensione",
    ORDER_HISTORY_ADD_REVIEW: "Scrivi una recensione",
    ORDER_HISTORY_SHIPPING_DETAIL: "Dettagli spedizione",
    ORDER_HISTORY_ARRIVAL_DATE: "Data arrivo",
    ORDER_HISTORY_TRACKING_NUMBER: "Numero di tracciabilità",
    ORDER_HISTORY_ORDER_INFO: "Informazioni ordine",
    ORDER_HISTORY_TOTAL_COST: "Costo totale",
    ORDER_HISTORY_ORDER_DATE: "Data ordine",
    ORDER_HISTORY_SHIP_DATE: "Data spedizione",
    ORDER_HISTORY_SHIP_LOCATION: "Luogo spedizione",
    CHECKOUT_PRE_VAT_SUBTOTAL: "Subtotale pre-IVA",
    CHECKOUT_VAT_TOTAL: "Totale IVA",
    CHECKOUT_PRE_VAT_SHIPPING: "Spedizione pre-IVA",
    CHECKOUT_SHIPPING_VAT: "IVA spedizione",
    CHECKOUT_ORDER_TOTAL: "Totale ordine",
    CHECKOUT_ORDER_INFORMATION_ERROR_MESSAGE:
      "Errore nelle informazioni dell’ordine, si prega di contattare l’assistenza Clienti.",
    SHARING_MFSP: "Prodotti più condivisi",
    SHARING_KWIK: "Kwik",
    SHARING_ESS: "Esplora, acquista e condividi",
    SHARING_FYNCTEM: "Trova la tua prossima campagna per guadagnare di più",
    ACCOUNT_PHONE_UNIQUE:
      "Questo numero di telefono è già associato a un account Kwik. Inserire un nuovo numero di telefono",
    CHECKOUT_ADDRESS_INVALID_FORMAT: "Formato non valido",
    VENDOR_INVENTORY_PLEASE_SELECT_WAREHOUSE: "Seleziona magazzino",
    VENDOR_INVENTORY_ADD_INVENTORY_FOR_SKU: "Aggiungi inventario per SKU#",
    ORDER_HISTORY_VIEW_DETAILS: "Visualizza dettagli",
    VENDOR_INVENTORY_EDIT_INVENTORY: "Modifica inventario",
    SHARING_NEW_TITLE: "Benvenuto su WeR1",
    VENDOR_PRODUCT_PSTCAW: "Seleziona Paese e magazzino!",
    VENDOR_PRODUCT_PSDCAW: "Seleziona Paese e magazzino diversi!",
    VENDOR_INVENTORY_ENTER_A_POSITIVE_OR_NEGATIVE_MESSAGE:
      "Inserisci un numero positivo o negativo per aggiungere o sottrarre dalla quantità assegnata.",
    VENDOR_INVENTORY_INVALID_VALUE: "Valore non valido?",
    PRODUCT_DETAIL_UPPER_LIMIT_OF_THE_INVENTORY:
      "Limite massimo dell’inventario",
    PRODUCTS_COPY_BUTTON: "Copia",
    PRODUCT_DETAIL_BACK_TO_PRODUCT_LIST: "Ritorna all’elenco prodotti",
    NEW_PRODUCT_ID: "Nuova ID prodotto",
    NEW_PRODUCT_NAME: "Nuovo nome prodotto",
    SHARING_TOP_DESC1: "Compra, condividi e guadagna su Kwik!",
    SHARING_TOP_DESC2_1: "Completa la",
    SHARING_TOP_DESC2_2: "Guida introduttiva",
    SHARING_TOP_DESC2_3: "qui sotto",
    SHARING_TOP_DESC3_1: "per guadagnare",
    SHARING_TOP_DESC3_2: "5$ USD in KwikCash!",
    SHARING_CHECKBOX_1: "Crea un account Kwik",
    SHARING_CHECKBOX_2: "Unisciti a una campagna",
    SHARING_CHECKBOX_3: "Condividi il tuo link",
    SHARING_CHECKBOX_4: "Visualizza il tuo KwikCash",
    SHARING_CHECKBOX_5: "Controlla le tue Onde",
    SHARING_ALL_PRODUCT: "Condividi tutti i prodotti",
    KWIKCASH_ADD_PAYPAL: "Aggiungi PayPal",
    ERC__CLICKING_CONFIRM_MESSAGE:
      'Si acconsente ai <a href="https://cms.kwik.com/Terms%26ConditionsWeR1.pdf" target=""_blank""><span>Termini</span></a> e <a href="https://cms.kwik.com/PrivacyPolicyWeR1.pdf.pdf" target=""_blank""><span>all’informativa sulla privacy di WeR1</span></a> ',
    KWIKCASH_CONNECT_TO_PAYPAL: "Collega a Paypal",
    KWIKCASH_PLEASE_INPUT_THE_AMOUNT: "Inserisci l'importo!",
    ENTER_LOGIN_EMAIL:
      "Inserisci il tuo indirizzo email per iniziare o effettuare il login!",
    I_FORGOT_PASSWORD: "Ho dimenticato la password",
    KWIKCASH_THE_ACCOUNT_NUMBER_SHOULD_BE_EMAIL_ADDRESS:
      "Il numero di account deve essere l’indirizzo email",
    REGISTER_WE_JUST_SEND_YOU_A_VERIFY_MESSAGE:
      "Ti abbiamo inviato un codice di verifica. Controlla le cartelle spam e promozioni.",
    REGISTER_RESEND_CODE: "Invia nuovo codice",
    REGISTER_CREATE_ACCOUNT: "Crea account",
    REGISTER_DONT_RECEIVED: "Non ricevuto?",
    REGISTER_SIGN_IN: "Accedi",
    REGISTER_ALREADY_A_MEMBER: "Già membro?",
    YOUR_EMAIL: "Il tuo indirizzo email",
    LET_FIND_LINK: "Troviamo il tuo link!",
    ENTER_EMAIL_FIND_LINK:
      "Inserisci il tuo indirizzo email e verificheremo che hai un link!",
    ENTER_LOGIN_CRED: "Inserisci le tue credenziali per continuare",
    SHARING_TOP_DESC2_NEW:
      "Per aiutarti a iniziare, abbiamo creato una checklist!",
    SHARING_TOP_DESC3_NEW: "Clicca QUI per saperne di più su Kwik.",
    SHARING_NO_LINK_TO_SHARE: "Nessun link da condividere?",
    SHARING_ITEM_TEXT_1: "Esplora il mercato di Kwik",
    SHARING_ITEM_TEXT_2: "Acquista un prodotto della marca che ami",
    SHARING_ITEM_TEXT_3: "Condividi un link al prodotto",
    SHARING_ITEM_TEXT_4: "Guadagna KwikCash",
    YOU_MAY_ALSO_LIKE: "Potrebbero interessarti anche",
    ADD_REVIEW: "Aggiungi una recensione",
    BE_FIRST_REVIEW: "Pubblica la prima recensione",
    COMMENT: "Commenta",
    REFERRAL_MESSAGE: "Messaggio di referral",
    VERIFIED_PURCHASER: "Acquirente verificato",
    COMMENTS: "Commenti",
    COPY_FROM_PROD: "Copia da prodotto",
    COPY_TO_PROD: "Copia a prodotto/i",
    KWIKCASH_PAYPAL_EMAIL_ADDRESS: "Indirizzo email",
    SHARELINK_PRODUCT_DETAIL_CASHBACK_ON_PURCHASE: "Cashback all’acquisto",
    SHARE: "Condividi",
    CASHBACK_ON_PURCHASE: "Cashback all’acquisto",
    EMAIL_NOT_REGISTERED: "Indirizzo email non registrato",
    SEND_SUCCESS: "Inviato con successo",
    LOGIN_KIHTM: "WeR1 è qui per rendere più facili",
    LOGIN_ERE: "i suggerimenti di tutti i giorni",
    PROCEED: "Procedi",
    TSIPBRATGPP:
      "Questo sito è protetto da reCAPTCHA e dall’informativa sulla privacy di Google",
    BRAND_NEW_TO_KWIK: "Nuovissimo di WeR1",
    CLICK_HERE_TO_CREATE: "Fai click qui per creare",
    LOOKING_TO_FIND_YOUR_LINK: "Stiamo cercando il link",
    CLICK_HERE_TO_FIND_IT: "Fai clic qui per trovarlo",
    SHARE_INFO_LAYER_CREATE_A_SHARE_LINK: "Crea un link di condivisione",
    SHARE_INFO_LAYER_GIVE_A_RATING: "Lascia una valutazione (facoltativo)",
    SHARE_INFO_LAYER_ADD_A_MESSAGE: "Aggiungi un messaggio (facoltativo)",
    SHARE_INFO_LAYER_250_WORDS_LEFT: "{{count}} parole rimanenti",
    SHARE_INFO_LAYER_ADD_ADDITIONAL_MEDIA: "Aggiungi altri media",
    SHARE_INFO_LAYER_UPLOAD: "Carica",
    SHARE_INFO_LAYER_SHARE_YOUR_LINK: "Condividi il link",
    SHARE_INFO_LAYER_COPY_LINK: "Copia link",
    SHARE_INFO_LAYER_THE_MAXIMUM_FILE_SIZE:
      "La dimensione massima del file è 80 MB",
    SHARE_INFO_LAYER_THE_FILE_FORMAT_IS_INCORRECT:
      "Il formato del file è scorretto",
    SHARE_INFO_LAYER_VERIFIED_PURCHASER: "Acquirente verificato",
    SHARE_INFO_LAYER_SUPER_AMAZING_PRODUCT: "WOW, PRODOTTO FANTASTICO!",
    USER_HAS_GOT_PASSWORD: "L’utente è già in possesso di una password!",
    INVALID_EMAIL: "Indirizzo email non valido",
    HEY_WE_MISS_YOU: "Ehi {{name}}, abbiamo sentito la tua mancanza!",
    LAST_REMEMBER_YOU: "L’ultima cosa che ricordiamo di te è",
    SAVE_YOUR_INFO_TEXT:
      "Speravamo di rivederti, e abbiamo salvato le tue informazioni.",
    PHONE_HAS_REGISTERED: "Il numero di telefono è stato registrato",
    IMPACT_OF_YOUR_RECOMMENDATIONS_1:
      "Vedi con i tuoi occhi il vero impatto dei",
    IMPACT_OF_YOUR_RECOMMENDATIONS_2: "suggerimenti che condividi.",
    FULL_NAME_NOT_BE_EMPTY: "Il nome non può rimanere vuoto",
    CODE_VERIFICATION: "Verifica del codice",
    ENTER_4_DIGIT_TIPS:
      "Inserisci il codice a 4 cifre che ti è stato inviato all’indirizzo",
    CHECK_JUNK_EMAIL_FOLDER:
      "Se non trovi un’email da KwikClick, controlla la tua cartella spam. Se usi Gmail, controlla nella categoria Promozioni.",
    PRODUCT_DETAIL_PAGE_CASHBACK_IS_THE_AMOUNT_MESSAGE:
      "Cashback è l’importo che guadagnerai immediatamente dopo aver acquistato questo prodotto. Sarà disponibile una volta completato il periodo di recesso.",
    LINK_HEADER_ALREADY_A_USER: "Già utente?",
    RESET_PASSWORD_PASS_RECOVERY: "Recupera la password",
    RESET_PASSWORD_ENTER_EMAIL_TIPS:
      "Inserisci l’indirizzo email che usi per WeR1",
    RESET_PASSWORD_SEND_TITLE: "Resetta la password",
    RESET_PASSWORD_SEND_TIPS_1: "Istruzioni inviate a: ",
    RESET_PASSWORD_SEND_TIPS_2:
      "se non hai ricevuto l’email, chiedi che ti vengano inviate di nuovo le istruzioni.",
    RESET_PASSWORD_SEND_BTN_BACK_SIGN_IN: "Torna all’accesso",
    RESET_PASSWORD_SEND_LINK_RESEND: "Invia di nuovo le istruzioni",
    RESET_PASSWORD_UPDATE_TIPS_SAME_PASS:
      "La password non corrisponde alla password di conferma",
    RESET_PASSWORD_UPDATE_TIPS_CONFIRM: "Conferma la nuova password",
    RESET_PASSWORD_UPDATE_SAVE_PASS: "Salva password",
    RESET_PASSWORD_SUCCESS_TIPS:
      "Password creata. Torna alla schermata di accesso.",
    RESET_PASSWORD_SUCCESS_LOGIN_ACCOUNT: "Accedi al tuo account",
    RESET_PASSWORD_SUCCESS_BACK_HOME: "Torna alla pagine home",
    RESET_PASSWORD_REQUIRED_EMAIL: "Il campo Email è obbligatorio",
    RESET_PASSWORD_RESEND_SUCCESS: "Nuovo invio riuscito",
    RESET_PASSWORD_CHOOSE_PASSWORD: "Scegli la nuova password",
    ALL_TIME: "Da sempre",
    LAST_DAY: "Ultimi {{day}} giorni",
    MY_CAMPAIGNS: "Le mie campagne",
    SHOW_MORE: "Mostra di più",
    SHOW_LESS: "Nascondi",
    OTHER_PRODUCTS: "Altri prodotti",
    CLICK_PRODUCT_SHOW:
      "Fai clic su un prodotto per visualizzare i dati relativi!",
    SEARCH_PRODUCT: "Cerca un prodotto",
    SHOWING_PAGE: "Mostra {{pagination}}",
    REFERRAL: "{{referral}} referral",
    PREVIOUS: "Precedente",
    NEXT: "Successivo",
    CASH: "Contanti",
    LEARN_KWIK: "Scopri Kwik",
    KWIK_TIPS: "Consigli su Kwik",
    WANT_LEARN_ABOUT: "Vuoi sapere quali dati vengono forniti da Kwik?",
    TOTAL_REFERRAL: "Referral totali generati",
    DIRECT_REFERRAL: "Referral diretti",
    WAVE_DEPTH: "Profondità d’onda",
    RECENT_ADDITIONS: "Novità",
    TRANSACTIONS: "Onde",
    TOP_SHARED_PRODUCT: "Primi {{count}} prodotti condivisi",
    VIEW_ALL: "Visualizza tutto",
    TOP_COUNTRIES: "Paesi top",
    ANALYTICS: "Analitiche",
    PEOPLE_REACHED: "Persone coinvolte",
    SHARES: "Condivisioni",
    LINK_CLICKS: "Numero di clic sul link",
    RECENT_SHARES: "Condivisioni recenti",
    DATE: "Data",
    PLATFORM: "Piattaforma",
    OPENED: "Viste",
    CONVERTED: "Convertito",
    SIGNED_UP: "Registrato",
    CLAIMS: "Affermazioni",
    ORDERED: "Ordinata",

    WAVE_SOURCES: "Sorgenti d’onda",
    REFERRAL_SUCCESS_RATE: "Tasso di successo dei referral",
    OPEN_RATE: "Tasso aperto",
    CONVERSION: "Conversione",
    IMPACT_RECOMMENDATIONS: "Suggerimenti di maggiore impatto",
    REFFERED_BRANDS: "Brand consigliati",
    REFERRED_BRANDS_DESCRIPTION: "Sono i brand che hai consigliato a Kwik.",
    SEARCH_BRAND: "Cerca un brand",
    SELECTED_CAMPAIGN: "Campagna selezionata",
    ACTIVE_CAMPAIGN: "Campagna attiva",
    SELECTED_CAMPAIGN_DESCRIPTION:
      "Stai visualizzando i dati relativi alla campagna “{{campaignName}}” ",
    SELECT_SPECIFIC_CAMPAIGN:
      "Seleziona una campagna per visualizzare solo i dati relativi a quella campagna specifica.",
    SEARCH_CAMPAIGN: "Cerca una campagna",
    GENERAL_SALES_INFO:
      "È l’importo in euro ricavato dalle vendite generate con i tuoi referral.",
    KWIKCASH_INFO: "È quanto hai guadagnato con i tuoi referral.",
    TOTAL_REFERRALS: "Referral totali",
    SALES_GENERATED: "Vendite generate",
    WAVE_NUMBER: "Onda {{number}}",
    MEMBERS: "Membri",
    MEMBERS_NUMBER: "Membri ({{number}})",
    SEARCH_MEMBER: "Cerca un membro",
    RECENT_REFERRALS: "Referral recenti",
    ALL_REFERRALS: "Tutti i referral",
    SHOPPING_PV: "PV",
    POLICY_POLICIES: "Politiche",
    POLICY_VTPTTBHUTK: "Visualizza le politiche caricate su Kwik dal brand",
    POLICY_SHIPPING_POLICY: "Politica di spedizione",
    POLICY_TAC: "Termini e Condizioni",
    POLICY_RP: "Politica di reso",
    POLICY_PP: "Informativa sulla privacy",
    POLICY_NOT_SEEING:
      "Non trovi quello che cerchi? Mettiti in contatto direttamente con il brand",
    DASHBOARD_PROFILE_STATUS: "Per iniziare",
    DASHBOARD_GET_5_CASHBACK:
      "Completa le 5 fasi per guadagnare 5 € di cashback!",
    DASHBOARD_COMPLETE_STEPS_EXPERT:
      "Completa queste fasi per diventare un esperto!",
    DASHBOARD_CREATE_ACCOUNT: "Crea un account",
    DASHBOARD_ALREADY_CREATED: "Già creato",
    DASHBOARD_DONE: "Fatto!",
    DASHBOARD_FAPOCWAB: "Trova un prodotto o mettiti in contatto con un brand",
    DASHBOARD_MAKE_A_REFER: "Fai un referral",
    DASHBOARD_SEE_ROLLIN:
      "Ottimo! Ora stai a guardare il tuo saldo che aumenta",
    DASHBOARD_SRAPTAF:
      "Invia a un amico un suggerimento di prodotto che va a buon fine",
    DASHBOARD_SHOW_ME_MONEY: "Mostrami il denaro",
    DASHBOARD_SEE_YOUR_IMPACT: "Vedi con i tuoi occhi l’impatto che hai",
    DASHBOARD_CLAIM_REWARD: "Richiedi reward",
    DASHBOARD_UPLOAD_IMAGE: "Carica immagine",
    DASHBOARD_HEY: "Ehi",
    DASHBOARD_WELCOME_TO_KWIK:
      "Benvenuto su WeR1! Questa è la dashboard. È il posto dove imparerai tutto quel che c’è da sapere su WeR1 e su come iniziare a condividere e guadagnare. Troverai anche del denaro gratis nella sezione “Per iniziare“ sulla destra!",
    DASHBOARD_WELCOME_TO_KWIK_MOBILE:
      "Benvenuto su WeR1! Questa è la dashboard. È il posto dove imparerai tutto quel che c’è da sapere su WeR1 e su come iniziare a condividere e guadagnare. Troverai anche del denaro gratis nella sezione “Per iniziare“ qui in basso!",
    DASHBOARD_WELCOME_TO_KWIK2:
      "Benvenuto su WeR1! Siamo felici per il tuo ultimo acquisto! Vogliamo aiutarti a condividere l’acquisto con gli altri in maniera significativa.",
    DASHBOARD_WELCOME_TO_KWIK3:
      "Potresti trovare qualcosa di diverso qui. Se hai perso l’ultimo aggiornamento, fai clic qui per vedere le nuove funzioni di WeR1!",
    DASHBOARD_WELCOME_TO_KWIK4:
      "Benvenuto su WeR1. È il modo più semplice e redditizio per consigliare prodotti agli amici e ai follower.",
    DASBOARD_LOOK_TO_THE_RIGHT: "Dai un’occhiata a destra",
    DASBOARD_LOOK_TO_BELOW: "Dai un’occhiata qui sotto",
    DASHBOARD_SALES_GENERATED: "Vendite generate",
    DASHBOARD_VIEW_ANALYTICS: "Visualizza analitiche",
    DASHBOARD_NOTIFICATION: "Notifiche",
    DASHBOARD_PURCHASED_FORM_YOUR_LINK: "Acquisti dal tuo link",
    MOST_RECENT: "Più recenti",
    KWIK: "Kwik",
    KB_VERSION: "KB",
    KB_THANKYOU: "Grazie!",
    KB_TITLE_01: "Nuove email",
    KB_TITLE_02: "Aggiornamenti KwikCash",
    KB_TITLE_03: "Modifiche alla pagina condivisioni",
    KB_TITLE_04: "Piccoli miglioramenti",
    KB_TITLE_05: "That's All Folks",
    KB_TITLE_06: "Correzioni bug",
    WELCOME_KWIK:
      "Benvenuto alla versione 1.3.7! Grandi cambiamenti. L’app ha modificato completamente un’altra schermata. Scopri quale e visualizza le altre modifiche.",
    THANKYOU_KWIK:
      "Siamo molto felici di questa versione e ancora più emozionati per la prossima. Facci sapere cosa ne pensi su <span>hello@wer1.com</span>, leggiamo e prendiamo in considerazione tutti i commenti!",
    WELCOME_KWIK_01: "Scopri cosa c’è di nuovo!",
    VERSION_DESC_01:
      "Le email di Kwik sono nuove di zecca! Sono più in linea col nostro stile e molto più efficaci della versione precedente.",
    VERSION_DESC_02:
      "Il denaro guadagnato su Kwik è essenziale! Ora il design ne riflette l’importanza.",
    VERSION_DESC_03:
      "Con ogni nuova versione, vogliamo rendere le condivisioni più accessibili e divertenti. Dai un’occhiata al nuovo design.",
    VERSION_DESC_04:
      "Questa versione include tanti piccoli cambiamenti. Eccone alcuni.",
    VERSION_DESC_05:
      "Grazie mille per aver partecipato a Kwik beta. Invia il tuo feedback a <span>hello@wer1.com</span>. Vogliamo ricevere i tuoi suggerimenti su come continuare a migliorare i nostri prodotti. Buon divertimento con 1.3.7.",
    VERSION_DESC_06:
      "Nella versione 1.3.6 ci sono tante correzioni di bug, per saperne di più dai un’occhiata alle note di rilascio, o semplicemente esplora Kwik. Tutti i dettagli stanno migliorando!",
    BASEHEADER_LINK_DASHBOARD: "Dashboard",
    NEW_SHARE_LINK_SAVE_FOR_LATER: "Salva per il futuro",
    NEW_SHARE_LINK_CART_TEXT_WHAT_WANT_SAVED:
      "Vuoi visualizzare quello che hai salvato? ",
    NEW_SHARE_LINK_CART_TEXT_OR: " o ",
    NEW_SHARE_LINK_CART_TEXT_CREATE_ACCOUNT: "Crea un account",
    NEW_SHARE_LINK_CART_TEXT_SIGN_IN: "Accedi",
    NEW_CHECKOUT_SELECT_SHIPPING_RATE:
      "Seleziona un metodo di spedizione per brand",
    NEW_CHECKOUT_TITLE_CART: "Carrello:",
    DASHBOARD_WELCOME_BACK: "Bentornato",
    DASHBOARD_MY_ORDERS: "I miei ordini",
    DASHBOARD_NO_ORDERS: "Nessun ordine",
    DASHBOARD_MADE_ORDER_TIPS:
      "Sembra che tu non abbia effettuato ordini da un brand tramite Kwik!",
    DASHBOARD_RECENT_SHARE: "Condivisione recente",
    DASHBOARD_SHARE_OTHER_PRODUCTS: "Condividi altri prodotti",
    DASHBOARD_SEE_MORE: "Vedi di più",
    DASHBOARD_SHOW_LESS: "Nascondi",
    DASHBOARD_WELCOME: "Benvenuto",
    ALREADY_SHARED_FAVOURITE:
      "Stai già condividendo i tuoi prodotti preferiti. Noi facciamo sì che sia facile guadagnare le commissioni che ti meriti.",
    SHOW_ME_HOW: "Mostra come",
    ALREADY_BRAND_AMBASSADOR: "— Sei già un ambasciatore del brand",
    WHY_MAKE_AMBASSADOR:
      "Perché non renderlo ufficiale? Kwik ti mette a disposizione gli strumenti necessari per far sì che condividere sia facile e divertente",
    MEET_SHARE_PAGE: "— Ti presentiamo la pagina condivisioni",
    MEET_SHARE_PAGE_DESC:
      "Sarà la tua nuova migliore amica. È dove potrai trovare tutti i tuoi link di referral e le campagne di prodotti.",
    SHARE_PAGE_FEATURE: "— Funzioni della pagina condivisioni",
    SHEARCH_FAVOURITE_PRODUCT:
      "<ul><li>Cerca i tuoi prodotti e brand preferiti da condividere.</li><li>Cerca singoli prodotti o l’intero catalogo del brand.</li></ul>",
    CUSTOM_LINKS_COLLECTION: "— Personalizza link e raccolte",
    PERSONAL_SHARE_LINK:
      "<ul><li>Personalizza il tuo link di condivisione con messaggi, immagini, video e recensioni originali. </li><li>Crea una raccolta di prodotti in base a interessi e attività simili.</li></ul>",
    GOT_IT: "OK",
    MEET_KWIK_CASH: "— Ti presentiamo KwikCash!",
    BEST_PART_USING_KWIK:
      "La cosa migliore di Kwik è che ti fa guadagnare! \n Il KwikCash può apparire in due forme: disponibile e in sospeso. Diventa disponibile una volta completato il periodo di recesso.",
    MONEY_MOVES: "— Movimenti di denaro",
    MONEY_MOVE_DESC:
      "<ul><li>Trasferisci denaro tramite ACH o PayPal</li><li>Visualizza il tuo KwikCash, scopri dove l’hai guadagnato, come l’hai speso e quando gli ultimi guadagni diventeranno disponibili.</li><li>Scopri di più su KwikCash qui.</li></ul>",
    MEET_CAMPAIGNS: "— Ti presentiamo le Campagne",
    MEET_CAMPAIGNS_DESC:
      "Qui è dove metti a frutto la tecnologia Blockchain. \n Tracciamo tutti i link, così puoi vedere con i tuoi occhi il vero impatto dei suggerimenti dei prodotti che condividi",
    KEY_FEATURES: "— Funzioni chiave",
    KEY_FEATURE_DESC:
      "<ul><li>I dati vengono suddivisi in tre livelli: tutte le campagne, campagne singole e singoli prodotti.</li><li>Utilizza le onde per vedere come un referral può generarne altri!</li></ul>",
    ADDITIONAL_FEATURES: "— Funzioni aggiuntive",
    ADDITIONAL_FEATURES_DESC:
      "<ul><li>Perso? Fai clic sull’icona 'I' per maggiori informazioni.</li><li>Per ulteriori dettagli su come funzionano le onde di guadagno e le campagne, <a href='https://kwik.com/work' target='_blank'>fai clic qui</a>.</li></ul>",
    KWIK_TEAM: "— Team Kwik",
    KWIK_TEAM_QUESTION:
      "<p>Hai domande o feedback? Scrivici! Invia un’email a <a href='mailto:hello@wer1.com'>hello@wer1.com</a></p><p>PS: Leggiamo tutti i messaggi. :) Grazie per averci aiutato a migliorare ancora Kwik!</p>",
    IAMREADY: "Sono pronto",
    DASHBOARD_PAGE: "— Dashboard",
    DASHBOARD_DESCRIPTION:
      "<p>La dashboard ti mostra i dati relativi agli ordini effettuati, ai contatti Kwik e alle campagne, oltre a consigli su come generare onde grazie ai referral di prodotti.</p><p>Dovresti trovare qualche informazione essenziale che ti aiuterà a iniziare!</p>",
    I_GOT_IT: "OK",
    DASHBOARD_CHECK_YOUR_EARINGS: "Controlla i tuoi guadagni",
    DASHBOARD_BLOG_ARTICLES: "Blog / Articoli",
    SETTINGS_GENERAL_CONTACT_REFERRER_FIRST_NAME:
      "Nome dell’autore del referral",
    SETTINGS_GENERAL_CONTACT_REFERRER_LAST_NAME:
      "Cognome dell’autore del referral",
    SETTINGS_GENERAL_CONTACT_REFERRER_NAME: "Nome dell’autore del referral",
    SETTINGS_GENERAL_CONTACT_REFERRER_EMAIL: "Email dell’autore del referral",
    VENDOR_FINANCE_TABLE_HD_DATE: "Data",
    VENDOR_FINANCE_TABLE_HD_TRANSACTION_STATUS: "Stato della transazione",
    VENDOR_FINANCE_TABLE_HD_TRANSACTION_METHOD: "Metodo della transazione",
    VENDOR_FINANCE_TABLE_HD_NET_PAYMENT: "Versamento netto",
    VENDOR_FINANCE_TABLE_HD_TYPE: "Tipo",
    VENDOR_FINANCE_TABLE_HD_KWIKCASH_TYPE: "Tipo di KwikCash",
    VENDOR_FINANCE_TABLE_HD_AMOUNT: "Importo",
    VENDOR_FINANCE_TABLE_HD_BALANCE: "Saldo",
    CAMPAIGNS_SELECTED_KWIKCASH: "1Cash",
    CAMPAIGNS_MY_CAMPAIGNS_THESE_ARE_THE_MESSAGE:
      "Sono le campagne a cui stai partecipando. Per crearne di nuove, acquista un prodotto dallo stesso brand e fai domanda direttamente a loro per diventare ambasciatore.",
    CAMPAIGNS_IMPACTFULRECOMMEND_THIS_WILL_SHOW_MESSAGE:
      "Mostra il referral da cui hai guadagnato di più.",
    DASHBOARD_SEE_LESS: "Nascondi",
    SHARELIINK_REGISTER_PASSWORD_PLACEHOLDER: "Password con almeno 8 caratteri",
    JOIN_CAMPAIGN_INFO:
      "Per unirsi a una campagna, devi avere esperienza diretta con il prodotto. Acquista ciò che vuoi promuovere, o mettiti in contatto con l’assistenza clienti per acquisti effettuati prima di entrare a far parte di Kwik. Presto ci saranno nuovi modi per unirsi a una campagna.",
    MAKE_REFERRAL_INFO:
      "Condividi un link a un prodotto con chi vuoi. Se lo acquistano, il tuo referral è andato a buon fine e il gioco è fatto!",
    CHECK_EARNINGS_INFO:
      "Semplice! Vai alla pagina KwikCash dal menu di navigazione.",
    CHECK_WAVES_INFO: "Vai alla pagina Campagne dal menu di navigazione.",
    CAMPAIGNS_ALL_CAMPAIGNS: "Tutte le campagne",
    CAMPAIGNS_WAVE_INSTANT_CASH_BACK: "Cashback istantaneo",
    CAMPAIGNS_WAVE_RECENT_CASH_BACK_ORDERS: "Ordini recenti con cashback",
    CAMPAIGNS_WAVE_ALL_CASH_BACK_ORDERS: "Tutti gli ordini con cashback",
    CAMPAIGNS_WAVE_CASHBACK_EARNED: "Cashback guadagnato",
    ALL_TIME2: "Da sempre",
    DASHBOARD_THIS_MONTH_ITEM2: "Questo mese",
    LAST_DAY2: "Ultimi {{day}} giorni",
    CAMPAIGNS_NO_SHARED_PRODUCTS: "Nessun prodotto condiviso",
    CAMPAIGNS_NO_MADE_REFERRALS:
      "Sembra che tu non abbia ancora condiviso suggerimenti o referral.",
    CAMPAIGNS_SHARE_SOMETHING: "Condividi",
    CAMPAIGNS_NO_WAVES: "Nessuna onda",
    CAMPAIGNS_ONLY_WORKS:
      "Le onde funzionano solo quando condividi con gli amici!",
    CAMPAIGNS_WAVE_TEXT_REFERRALS: "Referral",
    YOUR_ACCOUNT_ALMOST_CREATED: "Il tuo account è quasi completo!",
    ORDER_DETAIL_REVIEW_CONTENT_MESSAGE: "Lascia una recensione!",
    NEW_CHECKOUT_DELIVERY_INFORMATION: "Informazioni di consegna",
    NEW_CHECKOUT_EDIT: "Modifica",
    NEW_CHECKOUT_SHIPPING_METHOD: "Metodo di spedizione",
    NEW_CHECKOUT_PAYMENT_METHOD: "Metodo di pagamento",
    ENTER_LOGIN_EMAIL_NEW:
      "Inserisci il tuo indirizzo email, noi faremo il resto!",
    KWIKCASH_BALANCE_TITLE_AVAILABLE: "Saldo disponibile",
    KWIKCASH_BALANCE_TITLE_PENDING: "In sospeso",
    KWIKCASH_BALANCE_SEARCH_TRANSACTION_ID: "Cerca transazioni / ID",
    KWIKCASH_BALANCE_VIEW_TRANSACTIONS: "Visualizza transazioni",
    KWIKCASH_ALL_TIME: "Da sempre",
    KWIKCASH_THIS_MONTH: "Questo mese",
    KWIKCASH_LAST_7_DAYS_1: "Ultimi",
    KWIKCASH_LAST_7_DAYS_2: "7 giorni",
    KWIKCASH_TEXT_TRANSACTIONS: "Transazioni",
    KWIKCASH_TEXT_JOINED_WAVES: "Onde a cui hai partecipato",
    KWIKCASH_TEXT_Earnings: "Guadagni",
    KWIKCASH_CASH_OUT_TITLE: "Metodi di trasferimento di denaro",
    KWIKCASH_BTN_CASH_OUT: "Trasferisci",
    KWIKCASH_ADD_PAYMENT_BTN_NEXT_STEP: "Fase successiva",
    KWIKCASH_ADD_PAYMENT_BTN_BACK: "Indietro",
    KWIKCASH_ADD_PAYMENT_SELECT_TYPE_TITLE: "Seleziona tipo",
    KWIKCASH_ADD_PAYMENT_SELECT_TYPE_MSG:
      "Seleziona il tipo di account che vuoi aggiungere.",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_TITLE: "Aggiungi banca",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_1: "Inserisci i dati qui sotto per",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_2: "aggiungere un conto bancario",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_3:
      "Questi dati verranno salvati in modo sicuro secondo ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_4: "Termini di servizio e ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_5: "Informativa sulla privacy",
    KWIKCASH_ADD_PAYMENT_ADD_PAYPAL_MSG_1: "Inserisci i dati qui sotto per",
    KWIKCASH_ADD_PAYMENT_ADD_PAYPAL_MSG_2: "aggiungere un conto PayPal",
    KWIKCASH_CASH_OUT_TRANSFER_AMOUNT: "Invia importo",
    KWIKCASH_CASH_OUT_MSG1:
      "*È facile inviare denaro su uno qualsiasi dei conti collegati",
    KWIKCASH_CASH_OUT_METHOD: "Metodi di trasferimento di denaro",
    KWIKCASH_CASH_OUT_MSG21: "Per iniziare aggiungi il tuo primo ",
    KWIKCASH_CASH_OUT_MSG22: "metodo di",
    KWIKCASH_CASH_OUT_MSG23: "trasferimento",
    KWIKCASH_CASH_OUT_ADD: "Aggiungi metodo",
    KWIKCASH_CASH_OUT_LEARN_MORE: "Per saperne di più",
    KWIKCASH_TRANSACTION_STATUS_TIPS_DELIVERED:
      "Dovresti aver ricevuto il denaro!",
    KWIKCASH_TRANSACTION_STATUS_TIPS_INPROCESS:
      "Il trasferimento sta attraversando il processo per arrivare al tuo conto",
    KWIKCASH_TRANSACTION_STATUS_TIPS_CANCELED:
      "Questo trasferimento è stato cancellato",
    KWIKCASH_TRANSACTION_STATUS_TIPS_ONHOLD:
      "Il nostro team effettuando dei controlli. I trasferimenti di importi superiori a 500 € devono essere controllati dal team di Kwik. Questo dovrebbe impiegare meno di 24 ore.",
    KWIKCASH_TRANSACTION_CASH_OUT: "Transazioni di trasferimento del denaro",
    KWIKCASH_TRANSACTION_EXPORT: "Esporta",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TYPE: "Tipo",
    KWIKCASH_TRANSACTION_TABLE_HEADER_DATE: "Data",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TRANSACTION_ID: "ID transazione",
    KWIKCASH_TRANSACTION_TABLE_HEADER_AMOUNT: "Importo",
    KWIKCASH_TRANSACTION_TABLE_HEADER_STATUS: "Stato",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TRANSACTION_TYPE: "Tipo di transazione",
    KWIKCASH_TRANSACTION_TABLE_HEADER_BALANCE: "Saldo",
    KWIKCASH_TRANSACTION_TABLE_HEADER_WAVE: "Onda",
    KWIKCASH_TRANSACTION_TABLE_HEADER_INFLUENCER: "Influencer",
    KWIKCASH_TRANSACTION_TABLE_HEADER_AVAILABLE_DATE: "Data disponibile",
    KWIKCASH_TRANSACTION_NO_DATA_TITLE: "Nessuna transazione da visualizzare",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION1:
      "Inizia a condividere i tuoi prodotti con gli amici per ",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION2: "guadagnare 1Cash",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION3:
      " quindi trasferisci i tuoi guadagni e potrai visualizzarli qui :)",
    KWIKCASH_TRANSACTION_NO_DATA_BTN_START_SHARING: "Inizia a condividere",
    KWIKCASH_TRANSACTION_DETAIL_BACK: "Indietro",
    KWIKCASH_TRANSACTION_DETAIL_TRANSACTIONS: "Transazioni",
    KWIKCASH_TRANSACTION_DETAIL_NO_DATA: "Nessuna transazione da visualizzare",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION1:
      "Inizia a condividere i tuoi prodotti con gli amici per ",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION2: "guadagnare KwikCash",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION3:
      " quindi trasferisci i tuoi guadagni e potrai visualizzarli qui :)",
    KWIKCASH_VERIFY_NUMBER_TEXT_1:
      "Prima di continuare con 1Cash, verifica il tuo",
    KWIKCASH_VERIFY_NUMBER_TEXT_2: "indirizzo email",
    KWIKCASH_VERIFY_NUMBER_BTN: "Verifica ora",
    KWIKCASH_CASH_OUT_TIPS_SELECT_CARD: "Seleziona una carta bancaria!",
    KWIKCASH_CASH_OUT_MINIMUM_AMOUNTS:
      "L’importo minimo deve essere {{amount}}{{currency}}!",
    KWIKCASH_CASH_OUT_TIPS_AMOUNT_INVALID:
      "Non è possibile trasferire un importo superiore al saldo disponibile",
    KWIKCASH_CASH_OUT_TIPS_SENT_SUCCESS: "Codice inviato con successo",
    KWIKCASH_CASH_OUT_MODAL_TITLE: "Trasferisci",
    KWIKCASH_CASH_OUT_TIPS_MSG1: "Inserisci il ",
    KWIKCASH_CASH_OUT_TIPS_MSG2: "codice a 4 cifre",
    KWIKCASH_CASH_OUT_TIPS_MSG3: " per completare il trasferimento",
    KWIKCASH_CASH_OUT_TITLE_VERIFY: "Verifica per completare il trasferimento",
    KWIKCASH_CASH_OUT_TIPS_SENT_TO1: "Codice inviato a ",
    KWIKCASH_CASH_OUT_TIPS_DONT_RECEIVE: "Non hai ricevuto il codice? ",
    KWIKCASH_CASH_OUT_LINK_REQUEST_AGAIN: "Richiedi di nuovo",
    KWIKCASH_CASH_OUT_CONTENT_MSG1: "Seleziona il tuo ",
    KWIKCASH_CASH_OUT_CONTENT_MSG2: "metodo",
    KWIKCASH_CASH_OUT_CONTENT_MSG3:
      " di trasferimento, inserisci l’importo e premi invia!",
    KWIKCASH_CASH_OUT_AVAILABLE_BALANCE: "Saldo disponibile",
    KWIKCASH_CASH_OUT_SELECT_METHOD: "Seleziona un metodo di pagamento",
    KWIKCASH_CASH_OUT_TO_CITY_BANK: "a City Bank",
    KWIKCASH_CASH_OUT_TITLE_SUCCESS: "Bonifico effettuato!",
    KWIKCASH_CASH_OUT_SUCCESS_MSG1:
      "Il pagamento è stato inviato con successo e impiegherà ",
    KWIKCASH_CASH_OUT_SUCCESS_MSG2: "9-10 giorni lavorativi",
    KWIKCASH_CASH_OUT_SUCCESS_MSG3: " per essere processato",
    KWIKCASH_VERIFY_ENTER_EMAIL: "Inserisci un indirizzo email valido",
    KWIKCASH_VERIFY_ENTER_4_CODE: "Inserisci il codice a 4 cifre",
    KWIKCASH_VERIFY_EMAIL: "Verifica email",
    KWIKCASH_VERIFY_TIPS_1:
      "Invieremo un codice al tuo indirizzo email per assicurarci che la casella di posta appartenga a te",
    KWIKCASH_VERIFY_TIPS_ENTER_EMAIL: "Inserisci il tuo indirizzo email",
    KWIKCASH_VERIFY_MAKE_SURE_EMAIL:
      "Assicurati di aver inserito l’indirizzo email corretto.",
    KWIKCASH_VERIFY_CODE_SENT_TO: "Codice inviato a ",
    KWIKCASH_VERIFY_ENTER_EMAIL_CHECK: "L’email deve essere l’email di accesso",
    KWIKCASH_ADD_DIFFERENT_NUM: "I due numeri di conto sono diversi",
    KWIKCASH_ADD_SELECT_PAYMENT: "Seleziona un tipo di pagamento",
    KWIKCASH_ADD_ACCOUNT_ADDED: "Conto bancario aggiunto",
    KWIKCASH_ADD_ADDED_TIPS_1:
      "Tutto fatto! Il tuo conto bancario ora comparirà tra le opzioni di trasferimento. Goditi i tuoi guadagni :)",
    KWIKCASH_ADD_ADDED_PAYPAL: "Conto PayPal aggiunto",
    KWIKCASH_ADD_ADDED_TIPS_PAYPAL_1:
      "Tutto fatto! Il tuo conto PayPal ora comparirà tra le opzioni di trasferimento. Goditi i tuoi guadagni :)",
    KWIKCASH_ADD_VERIFY_TIPS_1: "Inserisci il ",
    KWIKCASH_ADD_VERIFY_TIPS_2: "codice a 4 cifre",
    KWIKCASH_ADD_VERIFY_TIPS_3: " per ",
    KWIKCASH_ADD_VERIFY_TIPS_ADD_PAYPAL: "aggiungere PayPal",
    KWIKCASH_ADD_VERIFY_TIPS_ADD_BANK: "aggiungere una banca",
    KWIKCASH_EDIT_BANK_ACCOUNT: "Modifica conto bancario",
    KWIKCASH_EDIT_VERIFY_REALLY_YOU: "Verifica identità",
    KWIKCASH_EDIT_PAYPAL_ACCOUNT: "Modifica conto PayPal",
    KWIKCASH_EDIT_PAYPAL_MSG_1:
      "Questi dati verranno salvati in modo sicuro secondo",
    KWIKCASH_EDIT_PAYPAL_MSG_2: "Termini di servizio e ",
    KWIKCASH_EDIT_PAYPAL_MSG_3: "Informativa sulla privacy.",
    KWIKCASH_EDIT_PAYPAL_VERIFY_MSG_1:
      "Verifica la tua identità qui sotto per ",
    KWIKCASH_EDIT_PAYPAL_VERIFY_MSG_2: "modificare un conto PayPal",
    KWIKCASH_EDIT_BANK_VERIFY_MSG_2: "modificare un conto bancario",
    KWIKCASH_TIPS_SELECT_COUNTRY: "Seleziona un Paese",
    KWIKCASH_TIPS_SELECT_CURRENCY: "Seleziona una valuta",
    KWIKCASH_MANAGE_CASH_OUT_METHOD:
      "Gestisci i tuoi metodi di trasferimento del denaro",
    KWIKCASH_CASH_OUT_METHOD2: "Metodi di trasferimento",
    KWIKCASH_ITS_EASY: "È facilissimo!",
    KWIKCASH_MANAGE_BTN_ADD: "+ Aggiungi",
    KWIKCASH_MANAGE_BTN_EDIT: "Modifica",
    KWIKCASH_MANAGE_BTN_CANCEL: "Annulla",
    KWIKCASH_MANAGE_TIPS_SELECT_METHOD:
      "Seleziona un metodo di trasferimento per modificare",
    KWIKCASH_MANAGE_REMOVE_PAYPAL: "Rimuovi PayPal",
    KWIKCASH_MANAGE_REMOVE_CARD: "Rimuovi Conto",
    KWIKCASH_MANAGE_TO_REMOVE_PAYPAL: " per rimuovere PayPal",
    KWIKCASH_MANAGE_TO_REMOVE_CARD: " per rimuovere la tua Conto",
    KWIKCASH_MANAGE_VERIFY_REMOVE: "Verifica per rimuovere ",
    KWIKCASH_MANAGE_VERIFY_TO: "Verifica per ",
    KWIKCASH_MANAGE_WORD_PAYPAL: "PayPal",
    KWIKCASH_MANAGE_WORD_CARD: "Conto",
    KWIKCASH_MANAGE_WORD_BANK: "Banca",
    KWIKCASH_MANAGE_ACCOUNT_REMOVED: "Conto rimosso",
    KWIKCASH_MANAGE_REMOVE_TIPS_1:
      "Una volta rimossa una carta, questa non comparirà più su KWIK.",
    KWIKCASH_MANAGE_BANK_ACCOUNT_UPDATED: "Conto bancario aggiornato",
    KWIKCASH_MANAGE_PAYPAL_ACCOUNT_UPDATED: "Conto PayPal aggiornato",
    KWIKCASH_MANAGE_BTN_ADD_ACCOUNT: "Verifica e aggiungi conto",
    KWIKCASH_BTN_CONFIRM_NUMBER: "Conferma numero",
    KWIKCASH_BTN_CONFIRM_EMAIL: "Conferma email",
    VENDOR_SETTINGS_UP: "Utenti e Autorizzazioni",
    VENDOR_SETTINGS_MWUCSODIYS:
      "Gestisci quello che gli altri utenti possono fare e visualizzare nel tuo negozio.",
    VENDOR_SETTINGS_BRAND_OWER: "Proprietario del brand",
    VENDOR_SETTINGS_ADDS_MEMBERS_TIPS: "Aggiungi membri (fino a 15)",
    VENDOR_SETTINGS_NO_DATA_TIPS:
      "Non hai aggiunto utenti. Aggiungi utenti per visualizzare i dettagli",
    VENDOR_SETTINGS_LAST_LOGIN: "Ultimo accesso",
    VENDOR_SETTINGS_ADD_USERS: "Aggiungi utente",
    VENDOR_SETTINGS_EDIT_USERS: "Modifica utente",
    VENDOR_SETTINGS_ETU_GOVERNMENTID:
      "Inserisci nome e cognome dell’utente così come compaiono sui documenti ufficiali.",
    VENDOR_SETTINGS_SELECT_PERMISSIONS: "Seleziona permessi",
    VENDOR_SETTINGS_SELECT_ALL: "Seleziona tutto",
    VERSION_DETAIL_01: "Biografia del venditore",
    VERSION_DETAIL_02: "Rimuovere descrizioni brevi",
    VERSION_DETAIL_03: "Informazioni di referral del venditore",
    VERSION_DETAIL_04: "Nessun nome o recensioni",
    VERSION_DETAIL_05: "Modifica carrello acquisti",
    VERSION_DETAIL_06:
      "Mostra il logo del venditore sulla schermata post-acquisto",
    VERSION_DETAIL_07: "Correzioni grammaticali",
    VERSION_DETAIL_08: "I dati mostrati sono errati",
    VERSION_DETAIL_09: "Mostra specifiche del prodotto",
    INVALID_LINK: "Link non valido",
    ORDER_LIST_ORDER_DATE: "Data ordine",
    VENDOR_ACCEPTING_ORDERS_STEP_1: "FASE 1",
    VENDOR_ACCEPTING_ORDERS_STEP_2: "FASE 2",
    VENDOR_ACCEPTING_ORDERS_STEP_3: "FASE 3",
    VENDOR_ACCEPTING_ORDERS_STEP_4: "FASE 4",
    VENDOR_ACCEPTING_ORDERS_STEP_5: "FASE 5",
    VENDOR_ACCEPTING_ORDERS_STEP_6: "FASE 6",
    VENDOR_ACCEPTING_ORDERS_TITLE_1:
      "Imposta luogo di partenza della spedizione",
    VENDOR_ACCEPTING_ORDERS_TITLE_2: "Aggiungi prodotti",
    VENDOR_ACCEPTING_ORDERS_TITLE_3: "Personalizza le tue campagne",
    VENDOR_ACCEPTING_ORDERS_TITLE_4: "Imposta tariffe di spedizione",
    VENDOR_ACCEPTING_ORDERS_TITLE_5: "Personalizza il tuo brand",
    VENDOR_ACCEPTING_ORDERS_TITLE_6: "Personalizza il tuo brand",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_1:
      "Questo garantirà una corretta tracciabilità della quantità indicata e aiuterà il coordinamento della spedizione. Abbiamo già un indirizzo salvato come il tuo indirizzo commerciale. Aggiornalo se è scorretto o se hai più di una sede.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_2:
      "Facci sapere quali prodotti vuoi inserire su Kwik, ci penseremo noi! Ci serve solo qualche informazione su ciascuno dei prodotti che desideri. Aggiungile con il nostro plugin Shopify, CVS import o manualmente.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_3:
      "È più semplice avere una sola campagna, quindi troverai questa impostazione di default. Questo significa che quando qualcuno si unisce alla tua campagna, può condividere tutti i tuoi prodotti. Se preferisci separarli, non c’è nessun problema!",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_4:
      "Questa fase è necessaria solo se vuoi partecipare al mercato di Kwik. Se t’interessa prendere parte, fai clic qui e ti mostreremo alcuni vantaggi :) In caso contrario, un semplice clic e via! ",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_5:
      "Abbiamo bisogno di alcuni dei tuoi design di brand più fighi per migliorare ancora la tua esperienza su Kwik. Aggiungi colori, immagini, biografia, ecc.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_6:
      "Abbiamo bisogno di alcuni dei tuoi design di brand più fighi per migliorare ancora la tua esperienza su Kwik. Aggiungi colori, immagini, biografia, ecc.",
    VENDOR_ACCEPTING_ORDERS_BTN_11_NAME: "Modifica magazzino",
    VENDOR_ACCEPTING_ORDERS_BTN_21_NAME: "Aggiungi prodotti",
    VENDOR_ACCEPTING_ORDERS_BTN_31_NAME: "Personalizza le campagne",
    VENDOR_ACCEPTING_ORDERS_BTN_41_NAME: "Imposta tariffe di spedizione",
    VENDOR_ACCEPTING_ORDERS_BTN_42_NAME: "Non sono interessato",
    VENDOR_ACCEPTING_ORDERS_BTN_51_NAME: "Personalizza il brand",
    VENDOR_ACCEPTING_ORDERS_BTN_61_NAME: "Personalizza il conto bancario",
    VENDOR_ACCEPTING_ORDERS_MENU_1: "Personalizza i magazzini",
    VENDOR_ACCEPTING_ORDERS_MENU_2: "Aggiungi prodotti",
    VENDOR_ACCEPTING_ORDERS_MENU_3: "Personalizza le campagne",
    VENDOR_ACCEPTING_ORDERS_MENU_4: "Imposta le campagne",
    VENDOR_ACCEPTING_ORDERS_MENU_5: "Personalizza il tuo brand",
    VENDOR_ACCEPTING_ORDERS_MENU_6: "Collega il conto bancario",
    VENDOR_ACCEPTING_ORDERS_TEXT_OF_6: " di 6",
    VENDOR_ACCEPTING_ORDERS_TEXT_COMPLETED: " Completati",
    VENDOR_ANALYTIC_REPORT_TITLE: "Report analitico",
    VENDOR_ANALYTIC_REPORT_TITLE_1: "Vendite totali",
    VENDOR_ANALYTIC_REPORT_TITLE_2: "Ordini totali",
    VENDOR_ANALYTIC_REPORT_TITLE_3: "Nuovi clienti",
    VENDOR_ANALYTIC_REPORT_TITLE_4: "Condividere clienti",
    VENDOR_ANALYTIC_REPORT_TIPS_1: "-----",
    VENDOR_OVERVIEW_COMPLETE_STEP_TITLE: "Completa l’impostazione",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_TITLE: "Imposta l’aliquota fiscale",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_MESSAGE:
      "Dobbiamo assicurarci della legalità della tua posizione e che tutto sia pronto per pagare le tasse",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_BTN_NAME:
      "Imposta aliquota fiscale",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_TITLE: "Aggiungi ambasciatori",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_MESSAGE:
      "Utenti per condivisioni non aggiunti, invia un link ad alcuni dei tuoi clienti più affezionati",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_BTN_NAME: "Aggiungi utenti",
    VENDOR_OVERVIEW_CUSTOMIZATION_TITLE: "Personalizzazione",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_TITLE: "Personalizza il tuo brand",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_MESSAGE:
      "Scegli colori e loghi visualizzabili dagli utenti. Rendi il tuo brand davvero personale.",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_BTN_NAME: "Personalizza",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_TITLE: "Aggiungi finanze",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_MESSAGE:
      "Assicurati di poter ricevere i guadagni dalle vendite e di avere un metodo per pagare chi vende i tuoi prodotti!",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_BTN_NAME: "Aggiorna ora",
    VENDOR_OVERVIEW_EARNERS_TITLE: "Venditori top",
    VENDOR_OVERVIEW_TABLE_TITLE: "Prodotti più venduti",
    VENDOR_OVERVIEW_TABLE_HEADER_1: "Immagine",
    VENDOR_OVERVIEW_TABLE_HEADER_2: "Nome prodotto",
    VENDOR_OVERVIEW_TABLE_HEADER_3: "Inventario",
    VENDOR_OVERVIEW_TABLE_HEADER_4: "Prezzo",
    VENDOR_OVERVIEW_TABLE_HEADER_5: "Vendite",
    VENDOR_OVERVIEW_TABLE_HEADER_6: "Valore KwikCash",
    SHOP_BY_CATEGORY: "Acquista per categoria",
    NEWEST_PRODUCTS: "Nuovi prodotti",
    PRODUCT_YOU_MIGHT_LIKE: "Prodotti che potrebbero piacerti",
    HIGHEST_KCASH: "1Cash più elevato",
    HIGHEST_INS_CASHBACK: "Cashback istantaneo più elevato",
    SEE_ALL: "Visualizza tutto",
    NEW_BRANDS_ON_KWIK: "Nuovi brand su Kwik",
    SHOP_BY_BRAND: "Acquista per brand",
    SHOPPING_EMAIL_TITLE1:
      "Vuoi scoprire quando verranno lanciati nuovi brand?",
    SHOPPING_EMAIL_DESC1:
      "Ricevi notifiche al lancio di nuovi brand su Kwik e sarai il primo a ricevere un link!",
    SHOPPING_EMAIL_TITLE2: "I tuoi suggerimenti arrivano lontano",
    SHOPPING_EMAIL_DESC2:
      "Il primo passo per condividere suggerimenti è trovare un prodotto che ami!",
    SHOPPING_EMAIL_DESC3:
      "Trova un prodotto che usi volentieri e Kwik ti aiuterà a condividerlo facilmente con gli amici e guadagnare!",
    ALL: "Tutto",
    RECENT_PURCHASES: "Ultimi acquisti",
    RECENTLY_PURCHASED_PRODUCTS: "Prodotti acquistati di recente",
    PAGE: "Pagina",
    PREV: "Precedente",
    TOP_SHARED_PRODUCTS: "Prodotti più condivisi",
    YOUR_PRODUCTS: "I tuoi prodotti",
    MOST_EARNED: "Più guadagni",
    MOST_SHARED: "Più condivisi",
    SEARCH: "Cerca",
    SEARCH_BY_PRODUCT_NAME: "Cerca per nome prodotto",
    CAMPAIGNS_YOU_HAVENT_JOINED_TEXT:
      "Non hai ancora partecipato a nessuna campagna :(",
    CAMPAIGNS_FIND_PRODUCTS_OR_CONNECT_TEXT:
      "Trova prodotti o mettiti in contatto con i brand per ricevere i link!",
    CAMPAIGNS_FIND_THE_BRANDS_TEXT: "Trova i brand",
    CAMPAIGNS_SHARES: "Condivisioni",
    CAMAPIGNS_NO_DATA: "Nessun dato",
    CAMPAIGNS_LOOKS_LIKE_YOU_HAVE_MESSAGE:
      "Sembra che tu non abbia ancora condiviso suggerimenti o referral.",
    CAMPAIGNS_LEARN_MORE_AT: "Per saperne di più vai a",
    CAMPAIGNS_SALES_FROM: "Vendite da",
    DESCRIPTION: "Description",
    INGREDIENTS: "Ingredients",
    USAGE: "Usage",
    MANUFACTURER: "Manufacturer",
    SHIPPING: "Shipping",
    CONGRATULATIONS: "Order Complete!",
    STANDARD: "Standard",
    FIELD_NAME_IBAN: "IBAN",
    FIELD_NAME_RE_IBAN: "Re-IBAN",
    FIELD_NAME_SORT_CODE: "Sort Code",
    FIELD_NAME_STATE: "State",
    FIELD_NAME_SWIFT_CODE: "Swift Code",
    FIELD_NAME_ZIP_CODE: "Postal Code",
    FIELD_RE_ACCOUNT_NUMBER: "Re-Enter Account Number",
    FIELD_SWIFT_CODE: "SWIFT",
    FIELD_BIC: "BIC",
    FIELD_BIC_CODE_SORT: "BIC/Sort Code",
    FIELD_BANK_BSB: "BSB",
    CANCEL: "Cancel",
    OK: "Ok",
    REFUND: "Refund",
    DELETE: "Delete",
    HEADER_SHOPPING: "Shopping",
    HELP: "Help",
    FIELD_REQUIRED: "This field is required",
    ACCONT_CONFIRM:
      "Changes to this type of account may require you to confirm the account. This will be done by entering the amounts of two small deposits into the account.",
    SS_FOOTER_MAIL_TO: "mailto:support@wer1.com",
    SS_FOOTER_HELLO_EMAIL: "hello@wer1.com",
    ORDER_AGAIN: "Order Again",
    VENDOR_SETTINGS_REFERRAL_NAME: "Referrer's Name",
    VENDOR_ACCEPTING_ORDERS_BTN_PREVIOUS: "Previous Step",
    VERSION_DETAIL_01_3_0_2: "Order Date in Order History",
    VERSION_DETAIL_02_3_0_2: "Share page keeps data when changing countries",
    VERSION_DETAIL_03_3_0_2: "Accurate numbers in product categories",
    VERSION_DETAIL_04_3_0_2: "Can’t share removed products",
    VERSION_DETAIL_05_3_0_2: "Campaigns search message",
    VERSION_DETAIL_06_3_0_2: "Available dates for pending Kwikcash",
    VERSION_DETAIL_07_3_0_2: "Post-purchase coin animation for guest users",
    VERSION_DETAIL_08_3_0_2:
      "Image shows in order history for removed products",
    VERSION_DETAIL_09_3_0_2:
      "Terms, Conditions, and Privacy Policy links updated",
    VERSION_DETAIL_10_3_0_2: "Typos!",
    VERSION_DETAIL_11_3_0_2: "Exported reports show countries for brands",
    VERSION_DETAIL_12_3_0_2:
      "Phone Number field is mandatory during brand sign up",
    VERSION_DETAIL_13_3_0_2: "Min & Max on vendor cashouts",
    VERSION_DETAIL_14_3_0_2: "Fixed vendor cash out issues",
    VERSION_DETAIL_15_3_0_2: "Added vendor password reset option",
    USER_SETTING_ACCOUNT_SETTINGS: "Account Settings",
    USER_SETTING_UPDATE_PROFILE: "Update Profile",
    USER_SETTING_ACCOUNT_INFO: "Account info",
    USER_SETTING_PUBLIC_ACCOUNT_NAME: "Public Account Name",
    USER_SETTING_PUBLIC_ACCOUNT_NAME_IS_REQUIRED:
      "Public Account Name is required",
    USER_SETTING_USERNAME: "Username",
    USER_SETTING_PUBLIC_ACCOUNT_USERNAME_IS_REQUIRED:
      "Public Account Username is required",
    USER_SETTING_CONTACT_DETAIL: "Contact Detail",
    USER_SETTING_EMAIL_ADDRESS: "Email Address",
    USER_SETTING_UPDATE_EMAIL_ADDRESS: "Update Email Address",
    USER_SETTING_UPDATE: "Update",
    USER_SETTING_PHONE_NUMBER: "Phone number",
    USER_SETTING_UPDATE_PHONE_NUMBER: "Update Phone Number",
    USER_SETTING_LOGIN: "Login",
    USER_SETTING_PASSWORD: "Password",
    USER_SETTING_LAST_UPDATED_AGO: "Last updated {{lastUpdatePwd}} ago",
    USER_SETTING_UPDATE_PASSWORD: "Update Password",
    USER_SETTING_LANGUAGE: "Language",
    USER_SETTING_UPDATE_LANGUAGE: "Update Language",
    USER_SETTING_COUNTRY: "Country",
    USER_SETTING_UPDATE_COUNTRY: "Update Country",
    USER_SETTING_ACCOUNT_DETAILS: "Account Details",
    USER_SETTING_THESE_CAN_BE_USED_TO_MAKE_MESSAGE:
      'These can be used to make sure that it\'s really you signing in or to contact you. To update these details contact our <a target="_blank" href="mailto:support@wer1.com">Customer Support</a>',
    USER_SETTING_LEGAL_NAME: "Legal Name",
    USER_SETTING_RECENT_LOGIN: "Recent Login",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_COMPUTER1:
      "{{sessionNum}} Session on {{system}} Computer",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_COMPUTER2:
      "{{sessionNum}} Sessions on {{system}} Computer",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_MOBILE1:
      "{{sessionNum}} Session on {{system}} mobile phone",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_MOBILE2:
      "{{sessionNum}} Sessions on {{system}} mobile phone",
    USER_SETTING_CHANGE_PASSWORD: "Change Password",
    USER_SETTING_ENTER_THE_DETAILS_BELOW_MESSAGE:
      "Enter the details below to <span>Change password</span> on WeR1.",
    USER_SETTING_ENTER_CURRENT_PASSWORD: "Enter Current Password",
    USER_SETTING_CURRENT_PASSWORD_IS_REQUIRED: "Current Password is required",
    USER_SETTING_INCORRECT_PASSWORD_FORMAT: "Incorrect password format",
    USER_SETTING_YOUR_NEW_PASSWORD: "Your New Password",
    USER_SETTING_NEW_PASSWORD_IS_REQUIRED: "New Password is required",
    USER_SETTING_RE_ENTER_YOUR_NEW_PASSWORD: "Re-Enter Your New Password",
    USER_SETTING_INCONSISTENT_PASSWORDS: "Inconsistent passwords",
    USER_SETTING_THIS_INFORMATION_WILL_BE_MESSAGE:
      'This information will be securely saved as per  the <span><a href="https://help.kwik.com/en/support/solutions/70000319669" target="_blank"><u>Terms of Service & Privacy Policy </u></a></span>',
    USER_SETTING_BACK: "Back",
    USER_SETTING_PASSWORD_SUCCESSFULLY_CHANGED: "Password Successfully Changed",
    USER_SETTING_YOU_CAN_NOW_USE_YOUR_MESSAGE:
      "You can now use your new password to <span>Log in to your account</span>",
    USER_SETTING_CHOOSE_A_LANGUAGE: "Choose a Language",
    USER_SETTING_YOUR_LANGUAGE_WILL_MESSAGE:
      "Your language will save the next time you load Kwik.",
    USER_SETTING_DEFAULT: "Default",
    USER_SETTING_SAVE: "Save",
    USER_SETTING_CHOOSE_A_COUNTRY: "Choose a Country",
    USER_SETTING_YOUR_COUNTRY_WILL_MESSAGE:
      "Your Country will save the next time you load Kwik.",
    USER_SETTING_MENU_SAVED_INFORMATION: "Saved Information",
    USER_SETTING_MENU_ADDRESSES: "Addresses",
    USER_SETTING_MENU_CASH_OUT_METHODS: "Cash Out Methods",
    USER_SETTING_MENU_PRIVACY_SETTINGS: "Privacy Settings",
    USER_SETTING_MENU_NOTIFICATION: "Notification",
    USER_SETTING_ADD_ADDRESS: "Add Address",
    USER_SETTING_ZIP_CODE: "Zip code",
    USER_SETTING_EDIT: "Edit",
    USER_SETTING_REMOVE: "Remove",
    USER_SETTING_SUBMIT: "Submit",
    USER_SETTING_PHONE_NUMBER2: "Phone Number",
    USER_SETTING_PHONE_NUMBER_IS_REQUIRED: "Phone Number is required",
    USER_SETTING_NAME: "Name",
    USER_SETTING_NAME_IS_REQUIRED: "Name is required",
    USER_SETTING_ADDRESS: "Address",
    USER_SETTING_ADDRESS_IS_REQUIRED: "Address is required",
    USER_SETTING_APARTIMENT_SUITE_ETC_OPTIONAL:
      "Apartment, Suite, Etc. (Optional)",
    USER_SETTING_CITY: "City",
    USER_SETTING_CITY_IS_REQUIRED: "City is required",
    USER_SETTING_STATE: "State",
    USER_SETTING_STATE_IS_REQUIRED: "State is required",
    USER_SETTING_POSTAL_CODE: "Postal Code",
    USER_SETTING_POSTAL_CODE_IS_REQUIRED: "Postal Code is required",
    USER_SETTING_EMAIL: "Email",
    USER_SETTING_EMAIL_IS_REQUIRED: "Email is required",
    USER_SETTING_GET_STARTED_BY_ADDING_MESSAGE:
      "Get started by adding your first <span>cash out</span> method!",
    USER_SETTING_ADD_METHOD: "Add Method",
    USER_SETTING_SHOW_MY_FULL_NAME_IN_WAVES: "Show My Full Name In Waves",
    USER_SETTING_ALLOW_USERS_TO_SEE_MESSAGE:
      "Allow users to see my full name in Waves",
    USER_SETTING_ALLOW_OTHER_USERS_TO_MESSAGE_ME:
      "Allow Other Users To Message Me",
    USER_SETTING_COMING_SOON: "Coming soon",
    USER_SETTING_SUBSCRIBE_TO_KWIK_NEWSLETTER: "Subscribe to Kwik Newsletter",
    USER_SETTING_ALL_WE_DO_IS_LET_MESSAGE:
      "All we do is let you know when we make your life better!",
    USER_SETTING_SUBSCRIBE_TO_NEWSLETTERS:
      "Subscribe To Newsletters From Vendors I Have Purchased From",
    USER_SETTING_AUTOMATICALLY_GET_MESSAGE:
      "Automatically get signed up for newsletters from the brands you bought from.",
    USER_SETTING_ALLOW_OTHER_USERS_MESSAGE:
      "Allow Other Users To See My Profile Photo In Their Waves",
    USER_SETTING_IF_ON_OTHERS_CAN_MESSAGE:
      "If on, others can see your profile photo in their waves.",
    USER_SETTING_DOWNLOAD_MY_DATA: "Download My Data",
    USER_SETTING_YOU_CAN_DOWNLOAD_MESSAGE:
      "You can download a copy of your data at any time",
    USER_SETTING_REQUEST_TO_DOWNLOAD_MU_DATA: "Request to Download My Data",
    USER_SETTING_DELETE_MY_DATA: "Delete My Data",
    USER_SETTING_YOU_CAN_DELETE_MESSAGE: "Delete the data stored in my account",
    USER_SETTING_NOTIFICATION_SETTINGS: "Notification Settings",
    USER_SETTING_NOTIFY_ME_ON: "Notify Me On",
    USER_SETTING_FINANCE: "Finance",
    USER_SETTING_CASHOUT_ALERTS: "Cashout Alerts",
    USER_SETTING_NOTIFY_ME_ON_EVERY_CASHOUT: "Notify me on every cash out",
    USER_SETTING_NEW_BANK_ACCOUNT_ADDED: "New Bank Account Added",
    USER_SETTING_NOTIFY_ME_WHEN_A_NEW_BANK_ACCOUNT_IS_ADDED:
      "Notify me when a new bank account is added",
    USER_SETTING_KWIKCASH_CLEARS: "1Cash Clears",
    USER_SETTING_WAVES: "Waves",
    USER_SETTING_WHEN_SOMEONE_JOINS_MY_WAVES: "When Someone Joins my Waves",
    USER_SETTING_NOTIFY_ME_EVERY_TIME_SOMEONE_JOINS_MY_WAVES:
      "Notify me every time someone joins my waves",
    USER_SETTING_MARKETING: "Marketing",
    USER_SETTING_SIGN_ME_UP_FOR_KWIK_NEWSLETTER:
      "Sign me up for Kwik Newsletter",
    USER_SETTING_GET_UPDATES_ON_THE_RELEASES_MESSAGE:
      "Get updates on the releases, and get important updates that might impact your account",
    USER_SETTING_ALLOW_BRANDS_MESSAGE:
      "Allow Brands to Send Me Their Newsletter",
    USER_SETTING_ALLOW_THE_BRANDS_OF_THE_MESSAGE:
      "Allow the brands of the campaigns I am in to send me newsletters by default",
    USER_SETTING_SHOPPING: "Shopping",
    USER_SETTING_NEW_BRANDS_ON_KWIK: "New Brands on Kwik",
    USER_SETTING_TRENDING_DEALS: "Trending Deals",
    USER_SETTING_SETTINGS: "Settings",
    USER_SETTING_ANY_SETTINGS_CHANGES_ARE_MADE: "Any settings changes are made",
    USER_SETTING_NOTIFY_ME_WHEN_ANY_SETTINGS_ARE_CHANGED:
      "Notify me when any settings are changed",
    USER_SETTING_LANGUAGE_CHANGED: "Language Changed",
    USER_SETTING_NOTIFY_ME_WHEN_THE_LANGUAGE_CHANGES:
      "Notify me when the language changes",
    USER_REGISTER_LEGAL_NAME: "Legal Name",
    USER_REGISTER_PLEASE_INPUT_YOUR_ADDRESS_LEGAL_NAME:
      "Please input your Address Legal Name",
    BRAND: "Brand",
  },
};
